/* tslint:disable */
/* eslint-disable */
/**
 * Planne Buyer API
 * Buyer-facing API gateway for Planne
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AddCartItemAdditional
 */
export interface AddCartItemAdditional {
    /**
     * 
     * @type {string}
     * @memberof AddCartItemAdditional
     */
    'additionalId': string;
    /**
     * 
     * @type {string}
     * @memberof AddCartItemAdditional
     */
    'inputValue'?: string;
    /**
     * Technical sanity bound, not a business rule. The buyer\'s real limit is the product\'s maxSaleQuantity.
     * @type {number}
     * @memberof AddCartItemAdditional
     */
    'quantity'?: number;
}
/**
 * 
 * @export
 * @interface AddCartItemRequest
 */
export interface AddCartItemRequest {
    /**
     * 
     * @type {string}
     * @memberof AddCartItemRequest
     */
    'productId': string;
    /**
     * 
     * @type {string}
     * @memberof AddCartItemRequest
     */
    'scheduleDate': string | null;
    /**
     * 
     * @type {number}
     * @memberof AddCartItemRequest
     */
    'scheduleTimeMinutes': number | null;
    /**
     * 
     * @type {Array<AddCartItemTariff>}
     * @memberof AddCartItemRequest
     */
    'tariffs': Array<AddCartItemTariff>;
    /**
     * 
     * @type {Array<AddCartItemResource>}
     * @memberof AddCartItemRequest
     */
    'resources': Array<AddCartItemResource>;
    /**
     * 
     * @type {Array<AddCartItemAdditional>}
     * @memberof AddCartItemRequest
     */
    'additionals': Array<AddCartItemAdditional>;
    /**
     * 
     * @type {string}
     * @memberof AddCartItemRequest
     */
    'affiliationCode'?: string;
    /**
     * 
     * @type {Array<SelectedTariffGroupAttributes>}
     * @memberof AddCartItemRequest
     */
    'selectedAttributes'?: Array<SelectedTariffGroupAttributes>;
    /**
     * Identifier of the upsell offer that originated this cart item. Null for items not added via upsell.
     * @type {string}
     * @memberof AddCartItemRequest
     */
    'upsellOfferId'?: string | null;
}
/**
 * 
 * @export
 * @interface AddCartItemResource
 */
export interface AddCartItemResource {
    /**
     * 
     * @type {string}
     * @memberof AddCartItemResource
     */
    'resourceId': string;
    /**
     * 
     * @type {Array<AddCartItemResourceTariff>}
     * @memberof AddCartItemResource
     */
    'tariffs': Array<AddCartItemResourceTariff>;
}
/**
 * 
 * @export
 * @interface AddCartItemResourceTariff
 */
export interface AddCartItemResourceTariff {
    /**
     * 
     * @type {string}
     * @memberof AddCartItemResourceTariff
     */
    'tariffId': string;
    /**
     * 
     * @type {number}
     * @memberof AddCartItemResourceTariff
     */
    'quantity': number;
}
/**
 * 
 * @export
 * @interface AddCartItemTariff
 */
export interface AddCartItemTariff {
    /**
     * 
     * @type {string}
     * @memberof AddCartItemTariff
     */
    'tariffId': string;
    /**
     * Technical sanity bound, not a business rule. The buyer\'s real limit is the product\'s maxSaleQuantity.
     * @type {number}
     * @memberof AddCartItemTariff
     * @deprecated
     */
    'quantity'?: number;
    /**
     * 
     * @type {Array<AddCartItemTariffVerificationParams>}
     * @memberof AddCartItemTariff
     */
    'verificationValues'?: Array<AddCartItemTariffVerificationParams> | null;
}
/**
 * 
 * @export
 * @interface AddCartItemTariffVerificationParams
 */
export interface AddCartItemTariffVerificationParams {
    /**
     * 
     * @type {string}
     * @memberof AddCartItemTariffVerificationParams
     */
    'tariffVerificationId': string;
    /**
     * 
     * @type {string}
     * @memberof AddCartItemTariffVerificationParams
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface AddCartItemsRequest
 */
export interface AddCartItemsRequest {
    /**
     * 
     * @type {Array<AddCartItemRequest>}
     * @memberof AddCartItemsRequest
     */
    'items': Array<AddCartItemRequest>;
}
/**
 * 
 * @export
 * @interface AddProductPackageToCartRequest
 */
export interface AddProductPackageToCartRequest {
    /**
     * 
     * @type {Array<CartProductPackageItemParams>}
     * @memberof AddProductPackageToCartRequest
     */
    'items': Array<CartProductPackageItemParams>;
}
/**
 * 
 * @export
 * @interface Additional
 */
export interface Additional {
    /**
     * 
     * @type {string}
     * @memberof Additional
     */
    'id': string;
    /**
     * 
     * @type {AdditionalType}
     * @memberof Additional
     */
    'type': AdditionalType;
    /**
     * 
     * @type {string}
     * @memberof Additional
     */
    'title': string;
    /**
     * 
     * @type {number}
     * @memberof Additional
     * @deprecated
     */
    'priceCents': number;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof Additional
     */
    'priceCurrencyInfo': CurrencyInfo;
    /**
     * 
     * @type {boolean}
     * @memberof Additional
     */
    'enableInput': boolean;
    /**
     * 
     * @type {string}
     * @memberof Additional
     */
    'description': string | null;
    /**
     * 
     * @type {Image}
     * @memberof Additional
     */
    'image': Image | null;
    /**
     * 
     * @type {string}
     * @memberof Additional
     */
    'inputLabel': string | null;
    /**
     * 
     * @type {Array<ExemptedTariffType>}
     * @memberof Additional
     */
    'exemptedTariffTypes': Array<ExemptedTariffType>;
    /**
     * 
     * @type {number}
     * @memberof Additional
     */
    'maxQuantity': number | null;
}


/**
 * 
 * @export
 * @interface AdditionalQuantity
 */
export interface AdditionalQuantity {
    /**
     * 
     * @type {string}
     * @memberof AdditionalQuantity
     */
    'additionalId': string;
    /**
     * 
     * @type {OccupationInfo}
     * @memberof AdditionalQuantity
     */
    'occupation': OccupationInfo;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const AdditionalType = {
    PerPerson: 'per_person',
    PerPersonWithInput: 'per_person_with_input',
    PerItem: 'per_item',
    PerQuantity: 'per_quantity'
} as const;

export type AdditionalType = typeof AdditionalType[keyof typeof AdditionalType];


/**
 * 
 * @export
 * @interface Address
 */
export interface Address {
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'zipCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'state'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'district'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'complement'?: string | null;
}
/**
 * 
 * @export
 * @interface AgreementComponent
 */
export interface AgreementComponent {
    /**
     * 
     * @type {Array<AgreementElement>}
     * @memberof AgreementComponent
     */
    'elements': Array<AgreementElement>;
    /**
     * 
     * @type {string}
     * @memberof AgreementComponent
     */
    'namedStyleType': string;
    /**
     * 
     * @type {string}
     * @memberof AgreementComponent
     */
    'listId': string | null;
}
/**
 * 
 * @export
 * @interface AgreementDocument
 */
export interface AgreementDocument {
    /**
     * 
     * @type {AgreementDocumentContent}
     * @memberof AgreementDocument
     */
    'content': AgreementDocumentContent;
}
/**
 * 
 * @export
 * @interface AgreementDocumentContent
 */
export interface AgreementDocumentContent {
    /**
     * 
     * @type {Array<AgreementComponent>}
     * @memberof AgreementDocumentContent
     */
    'components': Array<AgreementComponent>;
}
/**
 * 
 * @export
 * @interface AgreementElement
 */
export interface AgreementElement {
    /**
     * 
     * @type {string}
     * @memberof AgreementElement
     */
    'text': string;
    /**
     * 
     * @type {boolean}
     * @memberof AgreementElement
     */
    'bold': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AgreementElement
     */
    'underline': boolean;
    /**
     * 
     * @type {string}
     * @memberof AgreementElement
     */
    'linkUrl': string | null;
}
/**
 * 
 * @export
 * @interface App
 */
export interface App {
    /**
     * 
     * @type {string}
     * @memberof App
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof App
     */
    'logoUrl': string | null;
}
/**
 * 
 * @export
 * @interface AppInfo
 */
export interface AppInfo {
    /**
     * 
     * @type {string}
     * @memberof AppInfo
     */
    'id': string;
    /**
     * 
     * @type {boolean}
     * @memberof AppInfo
     */
    'hasCouponAvailable': boolean;
    /**
     * 
     * @type {string}
     * @memberof AppInfo
     */
    'recaptchaKey': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AppInfo
     */
    'allowForeignBuyers': boolean;
    /**
     * 
     * @type {FeaturedTariffPreviewMode}
     * @memberof AppInfo
     */
    'featuredTariffPreviewMode': FeaturedTariffPreviewMode | null;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof AppInfo
     * @deprecated
     */
    'featureFlags': { [key: string]: boolean; };
}


/**
 * 
 * @export
 * @interface Buyer
 */
export interface Buyer {
    /**
     * 
     * @type {string}
     * @memberof Buyer
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Buyer
     */
    'email': string | null;
    /**
     * 
     * @type {string}
     * @memberof Buyer
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof Buyer
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof Buyer
     */
    'fullName': string | null;
    /**
     * 
     * @type {string}
     * @memberof Buyer
     */
    'phone': string | null;
    /**
     * 
     * @type {string}
     * @memberof Buyer
     */
    'corporateName': string | null;
    /**
     * 
     * @type {string}
     * @memberof Buyer
     */
    'countryCode': string | null;
    /**
     * 
     * @type {string}
     * @memberof Buyer
     */
    'identityType': string | null;
    /**
     * 
     * @type {string}
     * @memberof Buyer
     */
    'identity': string | null;
    /**
     * 
     * @type {string}
     * @memberof Buyer
     */
    'birthdate': string | null;
    /**
     * 
     * @type {Address}
     * @memberof Buyer
     */
    'address': Address | null;
    /**
     * 
     * @type {boolean}
     * @memberof Buyer
     */
    'isExternal': boolean;
    /**
     * 
     * @type {string}
     * @memberof Buyer
     */
    'phoneVerifiedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof Buyer
     */
    'termsAgreementAt': string | null;
}
/**
 * 
 * @export
 * @interface Cart
 */
export interface Cart {
    /**
     * 
     * @type {string}
     * @memberof Cart
     */
    'customerId': string | null;
    /**
     * 
     * @type {CartCoupon}
     * @memberof Cart
     */
    'coupon': CartCoupon | null;
    /**
     * 
     * @type {SaleOrigin}
     * @memberof Cart
     */
    'saleOrigin': SaleOrigin | null;
    /**
     * 
     * @type {Array<CartItem>}
     * @memberof Cart
     */
    'items': Array<CartItem>;
    /**
     * 
     * @type {CartCostPreview}
     * @memberof Cart
     */
    'costPreview': CartCostPreview;
    /**
     * 
     * @type {Array<ErrorField>}
     * @memberof Cart
     */
    'generalErrors': Array<ErrorField>;
    /**
     * 
     * @type {string}
     * @memberof Cart
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface CartBase
 */
export interface CartBase {
    /**
     * 
     * @type {string}
     * @memberof CartBase
     */
    'customerId': string | null;
    /**
     * 
     * @type {CartCoupon}
     * @memberof CartBase
     */
    'coupon': CartCoupon | null;
    /**
     * 
     * @type {SaleOrigin}
     * @memberof CartBase
     */
    'saleOrigin': SaleOrigin | null;
    /**
     * 
     * @type {Array<CartItem>}
     * @memberof CartBase
     */
    'items': Array<CartItem>;
    /**
     * 
     * @type {CartCostPreview}
     * @memberof CartBase
     */
    'costPreview': CartCostPreview;
    /**
     * 
     * @type {Array<ErrorField>}
     * @memberof CartBase
     */
    'generalErrors': Array<ErrorField>;
}
/**
 * 
 * @export
 * @interface CartCostPreview
 */
export interface CartCostPreview {
    /**
     * 
     * @type {number}
     * @memberof CartCostPreview
     * @deprecated
     */
    'totalAmountCents': number;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof CartCostPreview
     */
    'totalAmountCurrencyInfo': CurrencyInfo;
    /**
     * 
     * @type {number}
     * @memberof CartCostPreview
     * @deprecated
     */
    'fullPartialAmountCents': number;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof CartCostPreview
     */
    'fullPartialAmountCurrencyInfo': CurrencyInfo;
    /**
     * 
     * @type {number}
     * @memberof CartCostPreview
     * @deprecated
     */
    'partialAmountCents': number;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof CartCostPreview
     */
    'partialAmountCurrencyInfo': CurrencyInfo;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof CartCostPreview
     */
    'serviceFeeCurrencyInfo': CurrencyInfo | null;
}
/**
 * 
 * @export
 * @interface CartCoupon
 */
export interface CartCoupon {
    /**
     * 
     * @type {string}
     * @memberof CartCoupon
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof CartCoupon
     */
    'formattedDiscount': string;
    /**
     * 
     * @type {number}
     * @memberof CartCoupon
     * @deprecated
     */
    'discountAmountCents': number | null;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof CartCoupon
     */
    'discountAmountCurrencyInfo': CurrencyInfo | null;
    /**
     * 
     * @type {number}
     * @memberof CartCoupon
     */
    'discountPercentage': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CartCoupon
     */
    'invalid': boolean;
    /**
     * 
     * @type {string}
     * @memberof CartCoupon
     */
    'type': CartCouponTypeEnum;
    /**
     * 
     * @type {CouponUsageType}
     * @memberof CartCoupon
     */
    'usageType': CouponUsageType;
    /**
     * 
     * @type {string}
     * @memberof CartCoupon
     */
    'constraintType': CartCouponConstraintTypeEnum | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CartCoupon
     */
    'productIds': Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CartCoupon
     */
    'appIds': Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof CartCoupon
     */
    'partnershipId': string | null;
    /**
     * 
     * @type {string}
     * @memberof CartCoupon
     */
    'agentName': string | null;
}

export const CartCouponTypeEnum = {
    Nominal: 'nominal',
    Percentage: 'percentage'
} as const;

export type CartCouponTypeEnum = typeof CartCouponTypeEnum[keyof typeof CartCouponTypeEnum];
export const CartCouponConstraintTypeEnum = {
    Include: 'include',
    Exclude: 'exclude'
} as const;

export type CartCouponConstraintTypeEnum = typeof CartCouponConstraintTypeEnum[keyof typeof CartCouponConstraintTypeEnum];

/**
 * 
 * @export
 * @interface CartItem
 */
export interface CartItem {
    /**
     * 
     * @type {string}
     * @memberof CartItem
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CartItem
     */
    'scheduleDate': string | null;
    /**
     * 
     * @type {number}
     * @memberof CartItem
     */
    'scheduleTimeMinutes': number | null;
    /**
     * 
     * @type {string}
     * @memberof CartItem
     */
    'formattedScheduleTimeMinutes': string | null;
    /**
     * 
     * @type {Product}
     * @memberof CartItem
     */
    'product': Product;
    /**
     * 
     * @type {Array<CartItemTariff>}
     * @memberof CartItem
     */
    'tariffs': Array<CartItemTariff>;
    /**
     * 
     * @type {Array<CartItemResource>}
     * @memberof CartItem
     */
    'resources': Array<CartItemResource>;
    /**
     * 
     * @type {Array<CartItemAdditional>}
     * @memberof CartItem
     */
    'additionals': Array<CartItemAdditional>;
    /**
     * 
     * @type {ServiceFee}
     * @memberof CartItem
     */
    'serviceFee': ServiceFee | null;
    /**
     * 
     * @type {CartItemCostPreview}
     * @memberof CartItem
     */
    'costPreview': CartItemCostPreview;
    /**
     * 
     * @type {Array<ErrorField>}
     * @memberof CartItem
     */
    'errors': Array<ErrorField>;
    /**
     * 
     * @type {string}
     * @memberof CartItem
     */
    'productPackageUnitId': string | null;
    /**
     * 
     * @type {string}
     * @memberof CartItem
     */
    'productPackageProductId': string | null;
    /**
     * 
     * @type {ProductPackageProduct}
     * @memberof CartItem
     */
    'productPackageProduct': ProductPackageProduct | null;
    /**
     * Identifier of the upsell offer that originated this cart item. Null for items not added via upsell.
     * @type {string}
     * @memberof CartItem
     */
    'upsellOfferId': string | null;
    /**
     * 
     * @type {Array<SelectedTariffGroupAttributes>}
     * @memberof CartItem
     */
    'selectedAttributes': Array<SelectedTariffGroupAttributes> | null;
}
/**
 * 
 * @export
 * @interface CartItemAdditional
 */
export interface CartItemAdditional {
    /**
     * 
     * @type {Additional}
     * @memberof CartItemAdditional
     */
    'additional': Additional;
    /**
     * 
     * @type {string}
     * @memberof CartItemAdditional
     */
    'formattedAmount': string;
    /**
     * 
     * @type {number}
     * @memberof CartItemAdditional
     */
    'quantity': number;
    /**
     * 
     * @type {number}
     * @memberof CartItemAdditional
     * @deprecated
     */
    'amountCents': number;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof CartItemAdditional
     */
    'amountCurrencyInfo': CurrencyInfo;
    /**
     * 
     * @type {Array<CartItemAdditionalTariff>}
     * @memberof CartItemAdditional
     */
    'tariffs': Array<CartItemAdditionalTariff> | null;
}
/**
 * 
 * @export
 * @interface CartItemAdditionalTariff
 */
export interface CartItemAdditionalTariff {
    /**
     * 
     * @type {string}
     * @memberof CartItemAdditionalTariff
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof CartItemAdditionalTariff
     */
    'quantity': number;
    /**
     * 
     * @type {number}
     * @memberof CartItemAdditionalTariff
     * @deprecated
     */
    'amountCents': number;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof CartItemAdditionalTariff
     */
    'amountCurrencyInfo': CurrencyInfo;
}
/**
 * 
 * @export
 * @interface CartItemCostPreview
 */
export interface CartItemCostPreview {
    /**
     * 
     * @type {number}
     * @memberof CartItemCostPreview
     * @deprecated
     */
    'totalPriceCents': number;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof CartItemCostPreview
     */
    'totalPriceCurrencyInfo': CurrencyInfo;
    /**
     * 
     * @type {number}
     * @memberof CartItemCostPreview
     * @deprecated
     */
    'packageDiscountCents': number;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof CartItemCostPreview
     */
    'packageDiscountCurrencyInfo': CurrencyInfo;
    /**
     * 
     * @type {number}
     * @memberof CartItemCostPreview
     * @deprecated
     */
    'minResourcePriceCents': number;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof CartItemCostPreview
     */
    'minResourcePriceCurrencyInfo': CurrencyInfo;
    /**
     * 
     * @type {number}
     * @memberof CartItemCostPreview
     * @deprecated
     */
    'resourcePriceCents': number;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof CartItemCostPreview
     */
    'resourcePriceCurrencyInfo': CurrencyInfo;
    /**
     * 
     * @type {number}
     * @memberof CartItemCostPreview
     * @deprecated
     */
    'productPackageOriginalDiscountCents': number | null;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof CartItemCostPreview
     */
    'productPackageOriginalDiscountCurrencyInfo': CurrencyInfo | null;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof CartItemCostPreview
     */
    'serviceFeeCurrencyInfo': CurrencyInfo | null;
}
/**
 * 
 * @export
 * @interface CartItemResource
 */
export interface CartItemResource {
    /**
     * 
     * @type {Resource}
     * @memberof CartItemResource
     */
    'resource': Resource;
    /**
     * 
     * @type {number}
     * @memberof CartItemResource
     * @deprecated
     */
    'minPriceCents': number | null;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof CartItemResource
     */
    'minPriceCurrencyInfo': CurrencyInfo | null;
}
/**
 * 
 * @export
 * @interface CartItemTariff
 */
export interface CartItemTariff {
    /**
     * 
     * @type {Tariff}
     * @memberof CartItemTariff
     */
    'tariff': Tariff;
    /**
     * 
     * @type {number}
     * @memberof CartItemTariff
     */
    'quantity': number;
    /**
     * 
     * @type {CartTariffCostPreview}
     * @memberof CartItemTariff
     */
    'costPreview': CartTariffCostPreview;
}
/**
 * The cart a seller assembled for a cart-type direct link. It carries no id, as it is not addressable through the buyer API, which reaches every cart by public id, and a mold cart has none. The buyer checks out a copy of it, created by POST /carts with the link\'s code.
 * @export
 * @interface CartMold
 */
export interface CartMold {
    /**
     * 
     * @type {string}
     * @memberof CartMold
     */
    'customerId': string | null;
    /**
     * 
     * @type {CartCoupon}
     * @memberof CartMold
     */
    'coupon': CartCoupon | null;
    /**
     * 
     * @type {SaleOrigin}
     * @memberof CartMold
     */
    'saleOrigin': SaleOrigin | null;
    /**
     * 
     * @type {Array<CartItem>}
     * @memberof CartMold
     */
    'items': Array<CartItem>;
    /**
     * 
     * @type {CartCostPreview}
     * @memberof CartMold
     */
    'costPreview': CartCostPreview;
    /**
     * 
     * @type {Array<ErrorField>}
     * @memberof CartMold
     */
    'generalErrors': Array<ErrorField>;
}
/**
 * 
 * @export
 * @interface CartProductPackageItemParams
 */
export interface CartProductPackageItemParams {
    /**
     * 
     * @type {string}
     * @memberof CartProductPackageItemParams
     */
    'productPackageProductId': string;
    /**
     * 
     * @type {AddCartItemRequest}
     * @memberof CartProductPackageItemParams
     */
    'item': AddCartItemRequest;
}
/**
 * 
 * @export
 * @interface CartTariffCostPreview
 */
export interface CartTariffCostPreview {
    /**
     * 
     * @type {number}
     * @memberof CartTariffCostPreview
     * @deprecated
     */
    'unitPriceCents': number;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof CartTariffCostPreview
     */
    'unitPriceCurrencyInfo': CurrencyInfo;
}
/**
 * 
 * @export
 * @interface CheckoutCartRequest
 */
export interface CheckoutCartRequest {
    /**
     * 
     * @type {Array<UtmParams>}
     * @memberof CheckoutCartRequest
     */
    'utms': Array<UtmParams> | null;
}
/**
 * 
 * @export
 * @interface CompleteDirectLink
 */
export interface CompleteDirectLink {
    /**
     * 
     * @type {string}
     * @memberof CompleteDirectLink
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CompleteDirectLink
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof CompleteDirectLink
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof CompleteDirectLink
     */
    'status': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CompleteDirectLink
     */
    'isExpired': boolean;
    /**
     * 
     * @type {number}
     * @memberof CompleteDirectLink
     * @deprecated
     */
    'totalAmountCents': number;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof CompleteDirectLink
     */
    'totalAmountCurrencyInfo': CurrencyInfo;
    /**
     * 
     * @type {string}
     * @memberof CompleteDirectLink
     */
    'customMessage': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CompleteDirectLink
     */
    'enablePayment': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CompleteDirectLink
     */
    'expiresAt': string;
    /**
     * 
     * @type {App}
     * @memberof CompleteDirectLink
     */
    'app': App;
    /**
     * 
     * @type {string}
     * @memberof CompleteDirectLink
     */
    'saleId': string | null;
    /**
     * Order created by an order-type link. Its sales and items are read through GET /orders/{orderId}, which already returns products, tariffs and prices.
     * @type {string}
     * @memberof CompleteDirectLink
     */
    'orderId': string | null;
    /**
     * 
     * @type {string}
     * @memberof CompleteDirectLink
     */
    'customerId': string;
    /**
     * 
     * @type {Transaction}
     * @memberof CompleteDirectLink
     */
    'lastTransaction': Transaction | null;
    /**
     * 
     * @type {string}
     * @memberof CompleteDirectLink
     */
    'createdAt': string;
    /**
     * 
     * @type {CartMold}
     * @memberof CompleteDirectLink
     */
    'cartMold': CartMold | null;
}
/**
 * 
 * @export
 * @interface ConfirmBuyerEmailChangeRequest
 */
export interface ConfirmBuyerEmailChangeRequest {
    /**
     * 
     * @type {string}
     * @memberof ConfirmBuyerEmailChangeRequest
     */
    'code': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const CouponUsageType = {
    General: 'general',
    Mixed: 'mixed',
    Product: 'product'
} as const;

export type CouponUsageType = typeof CouponUsageType[keyof typeof CouponUsageType];


/**
 * 
 * @export
 * @interface CreateCartRequest
 */
export interface CreateCartRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCartRequest
     */
    'directLinkCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCartRequest
     */
    'saleOriginCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCartRequest
     */
    'affiliationCode'?: string;
}
/**
 * 
 * @export
 * @interface CurrencyInfo
 */
export interface CurrencyInfo {
    /**
     * Converted amount in cents
     * @type {number}
     * @memberof CurrencyInfo
     */
    'amountCents': number;
    /**
     * Destination currency
     * @type {string}
     * @memberof CurrencyInfo
     */
    'currency': string;
    /**
     * Original amount in cents
     * @type {number}
     * @memberof CurrencyInfo
     */
    'originalAmountCents': number;
    /**
     * Source currency
     * @type {string}
     * @memberof CurrencyInfo
     */
    'originalCurrency': string;
}
/**
 * 
 * @export
 * @interface DateAndTimeAdditionalScheduleQuantity
 */
export interface DateAndTimeAdditionalScheduleQuantity {
    /**
     * 
     * @type {string}
     * @memberof DateAndTimeAdditionalScheduleQuantity
     */
    'additionalId': string;
    /**
     * 
     * @type {Array<DateAndTimeScheduleQuantity>}
     * @memberof DateAndTimeAdditionalScheduleQuantity
     */
    'occupationSchedule': Array<DateAndTimeScheduleQuantity>;
}
/**
 * 
 * @export
 * @interface DateAndTimeScheduleQuantity
 */
export interface DateAndTimeScheduleQuantity {
    /**
     * 
     * @type {number}
     * @memberof DateAndTimeScheduleQuantity
     */
    'minutes': number;
    /**
     * 
     * @type {OccupationInfo}
     * @memberof DateAndTimeScheduleQuantity
     */
    'occupation': OccupationInfo;
}
/**
 * 
 * @export
 * @interface DateAndTimeTariffScheduleQuantity
 */
export interface DateAndTimeTariffScheduleQuantity {
    /**
     * 
     * @type {string}
     * @memberof DateAndTimeTariffScheduleQuantity
     */
    'tariffId': string;
    /**
     * 
     * @type {Array<DateAndTimeScheduleQuantity>}
     * @memberof DateAndTimeTariffScheduleQuantity
     */
    'occupationSchedule': Array<DateAndTimeScheduleQuantity>;
}
/**
 * 
 * @export
 * @interface DetailedSaleItem
 */
export interface DetailedSaleItem {
    /**
     * 
     * @type {string}
     * @memberof DetailedSaleItem
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DetailedSaleItem
     */
    'scheduleDate': string | null;
    /**
     * 
     * @type {number}
     * @memberof DetailedSaleItem
     */
    'scheduleTimeMinutes': number | null;
    /**
     * 
     * @type {string}
     * @memberof DetailedSaleItem
     */
    'formattedScheduleTimeMinutes': string | null;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof DetailedSaleItem
     */
    'totalPriceCurrencyInfo': CurrencyInfo;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof DetailedSaleItem
     */
    'basePriceCurrencyInfo': CurrencyInfo;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof DetailedSaleItem
     */
    'fullPriceCurrencyInfo': CurrencyInfo;
    /**
     * 
     * @type {Product}
     * @memberof DetailedSaleItem
     */
    'product': Product;
    /**
     * 
     * @type {string}
     * @memberof DetailedSaleItem
     */
    'productPackageUnitId': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailedSaleItem
     */
    'productPackageProductId': string | null;
    /**
     * 
     * @type {ProductPackageProduct}
     * @memberof DetailedSaleItem
     */
    'productPackageProduct': ProductPackageProduct | null;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof DetailedSaleItem
     */
    'productPackageOriginalDiscountCurrencyInfo': CurrencyInfo | null;
    /**
     * 
     * @type {string}
     * @memberof DetailedSaleItem
     */
    'serviceFeeId': string | null;
    /**
     * 
     * @type {ServiceFee}
     * @memberof DetailedSaleItem
     */
    'serviceFee': ServiceFee | null;
    /**
     * 
     * @type {ServiceFeeTypeEnum}
     * @memberof DetailedSaleItem
     */
    'serviceFeeType': ServiceFeeTypeEnum | null;
    /**
     * 
     * @type {number}
     * @memberof DetailedSaleItem
     */
    'serviceFeePercentage': number | null;
    /**
     * 
     * @type {number}
     * @memberof DetailedSaleItem
     */
    'serviceFeeAmountCents': number | null;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof DetailedSaleItem
     */
    'serviceFeeCurrencyInfo': CurrencyInfo | null;
    /**
     * Identifier of the upsell offer that originated this sale item. Propagated from the cart item on checkout.
     * @type {string}
     * @memberof DetailedSaleItem
     */
    'upsellOfferId': string | null;
    /**
     * 
     * @type {Array<SelectedTariffGroupAttributes>}
     * @memberof DetailedSaleItem
     */
    'selectedAttributes'?: Array<SelectedTariffGroupAttributes> | null;
    /**
     * 
     * @type {string}
     * @memberof DetailedSaleItem
     */
    'reservationId': string | null;
    /**
     * 
     * @type {number}
     * @memberof DetailedSaleItem
     */
    'quantity': number;
    /**
     * 
     * @type {number}
     * @memberof DetailedSaleItem
     * @deprecated
     */
    'totalPriceCents': number;
    /**
     * Sum of tariffs, resources, and add-ons in cents before the service fee and before discount coupons (same as pre-fee line subtotal). 
     * @type {number}
     * @memberof DetailedSaleItem
     */
    'basePriceCents': number;
    /**
     * 
     * @type {number}
     * @memberof DetailedSaleItem
     * @deprecated
     */
    'fullPriceCents': number;
    /**
     * 
     * @type {Array<SaleTariff>}
     * @memberof DetailedSaleItem
     */
    'tariffs': Array<SaleTariff>;
    /**
     * 
     * @type {Array<SaleResource>}
     * @memberof DetailedSaleItem
     */
    'resources': Array<SaleResource>;
    /**
     * 
     * @type {Array<SaleAdditional>}
     * @memberof DetailedSaleItem
     */
    'additionals': Array<SaleAdditional>;
    /**
     * 
     * @type {number}
     * @memberof DetailedSaleItem
     * @deprecated
     */
    'resourcePriceCents': number;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof DetailedSaleItem
     */
    'resourcePriceCurrencyInfo': CurrencyInfo | null;
    /**
     * 
     * @type {number}
     * @memberof DetailedSaleItem
     * @deprecated
     */
    'productPackageOriginalDiscountCents': number | null;
    /**
     * 
     * @type {Array<SaleChange>}
     * @memberof DetailedSaleItem
     */
    'saleChanges': Array<SaleChange>;
    /**
     * 
     * @type {RescheduleInfo}
     * @memberof DetailedSaleItem
     */
    'rescheduleInfo': RescheduleInfo;
}


/**
 * 
 * @export
 * @interface DetailedTariffGroup
 */
export interface DetailedTariffGroup {
    /**
     * 
     * @type {Array<Tariff>}
     * @memberof DetailedTariffGroup
     */
    'tariffs': Array<Tariff>;
    /**
     * 
     * @type {string}
     * @memberof DetailedTariffGroup
     */
    'serviceFeeId': string | null;
    /**
     * 
     * @type {ServiceFee}
     * @memberof DetailedTariffGroup
     */
    'serviceFee': ServiceFee | null;
    /**
     * 
     * @type {Array<TariffGroupAttribute>}
     * @memberof DetailedTariffGroup
     */
    'attributes'?: Array<TariffGroupAttribute>;
}
/**
 * 
 * @export
 * @interface DeviceInfoParams
 */
export interface DeviceInfoParams {
    /**
     * 
     * @type {string}
     * @memberof DeviceInfoParams
     */
    'language': string;
    /**
     * 
     * @type {number}
     * @memberof DeviceInfoParams
     */
    'screenHeight': number;
    /**
     * 
     * @type {number}
     * @memberof DeviceInfoParams
     */
    'screenWidth': number;
    /**
     * The browser\'s difference to UTC in minutes, as JavaScript\'s getTimezoneOffset() returns it (Brazil is 180).
     * @type {number}
     * @memberof DeviceInfoParams
     */
    'timeZoneOffset': number;
}
/**
 * 
 * @export
 * @interface DirectLink
 */
export interface DirectLink {
    /**
     * 
     * @type {string}
     * @memberof DirectLink
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DirectLink
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof DirectLink
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof DirectLink
     */
    'status': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DirectLink
     */
    'isExpired': boolean;
    /**
     * 
     * @type {number}
     * @memberof DirectLink
     * @deprecated
     */
    'totalAmountCents': number;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof DirectLink
     */
    'totalAmountCurrencyInfo': CurrencyInfo;
    /**
     * 
     * @type {string}
     * @memberof DirectLink
     */
    'customMessage': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DirectLink
     */
    'enablePayment': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof DirectLink
     */
    'expiresAt': string;
    /**
     * 
     * @type {App}
     * @memberof DirectLink
     */
    'app': App;
    /**
     * 
     * @type {string}
     * @memberof DirectLink
     */
    'saleId': string | null;
    /**
     * Order created by an order-type link. Its sales and items are read through GET /orders/{orderId}, which already returns products, tariffs and prices.
     * @type {string}
     * @memberof DirectLink
     */
    'orderId': string | null;
    /**
     * 
     * @type {string}
     * @memberof DirectLink
     */
    'customerId': string;
    /**
     * 
     * @type {Transaction}
     * @memberof DirectLink
     */
    'lastTransaction': Transaction | null;
    /**
     * 
     * @type {string}
     * @memberof DirectLink
     */
    'createdAt': string;
}
/**
 * 
 * @export
 * @interface EmailAvailability
 */
export interface EmailAvailability {
    /**
     * 
     * @type {boolean}
     * @memberof EmailAvailability
     */
    'available': boolean;
}
/**
 * 
 * @export
 * @interface ErrorField
 */
export interface ErrorField {
    /**
     * 
     * @type {string}
     * @memberof ErrorField
     */
    'path': string;
    /**
     * 
     * @type {string}
     * @memberof ErrorField
     */
    'type': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ErrorField
     */
    'extra': { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * 
     * @type {number}
     * @memberof ErrorResponse
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'message': string;
    /**
     * 
     * @type {Array<ErrorField>}
     * @memberof ErrorResponse
     */
    'errors'?: Array<ErrorField>;
}
/**
 * 
 * @export
 * @interface ExemptedTariffType
 */
export interface ExemptedTariffType {
    /**
     * 
     * @type {string}
     * @memberof ExemptedTariffType
     */
    'tariffTypeId': string;
}
/**
 * External authentication provider. Keys the provider implementation and the challenge component on the client.
 * @export
 * @enum {string}
 */

export const ExternalAuthenticationProviderType = {
    Bpmpi: 'bpmpi',
    Pgmpi: 'pgmpi',
    Malga3ds2: 'malga3ds2'
} as const;

export type ExternalAuthenticationProviderType = typeof ExternalAuthenticationProviderType[keyof typeof ExternalAuthenticationProviderType];


/**
 * 
 * @export
 * @interface ExternalAuthenticationSetupParams
 */
export interface ExternalAuthenticationSetupParams {
    /**
     * Card data. Expected by providers that tokenize before the 3DS setup (malga3ds2); omitted for providers whose setup is card-independent (bpmpi, pgmpi).
     * @type {PaymentCardParams}
     * @memberof ExternalAuthenticationSetupParams
     */
    'paymentCard'?: PaymentCardParams;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const FeaturedTariffPreviewMode = {
    Default: 'default',
    Highest: 'highest',
    Lowest: 'lowest'
} as const;

export type FeaturedTariffPreviewMode = typeof FeaturedTariffPreviewMode[keyof typeof FeaturedTariffPreviewMode];


/**
 * 
 * @export
 * @interface FormInput
 */
export interface FormInput {
    /**
     * 
     * @type {string}
     * @memberof FormInput
     */
    'id': string;
    /**
     * 
     * @type {FormInputType}
     * @memberof FormInput
     */
    'type': FormInputType;
    /**
     * 
     * @type {FormInputInputType}
     * @memberof FormInput
     */
    'inputType': FormInputInputType;
    /**
     * 
     * @type {string}
     * @memberof FormInput
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof FormInput
     */
    'required': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormInput
     */
    'validationRules': Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof FormInput
     */
    'sequence': number;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const FormInputInputType = {
    Text: 'text',
    Phone: 'phone',
    Email: 'email',
    Date: 'date'
} as const;

export type FormInputInputType = typeof FormInputInputType[keyof typeof FormInputInputType];


/**
 * 
 * @export
 * @enum {string}
 */

export const FormInputType = {
    PerSale: 'per_sale',
    PerSaleItem: 'per_sale_item',
    PerTariffType: 'per_tariff_type',
    PerTariff: 'per_tariff'
} as const;

export type FormInputType = typeof FormInputType[keyof typeof FormInputType];


/**
 * 
 * @export
 * @interface Image
 */
export interface Image {
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    'id': string;
    /**
     * 
     * @type {Array<ImageStyle>}
     * @memberof Image
     */
    'styles': Array<ImageStyle>;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    'alternativeText': string;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    'createdAt': string;
}
/**
 * 
 * @export
 * @interface ImageStyle
 */
export interface ImageStyle {
    /**
     * 
     * @type {string}
     * @memberof ImageStyle
     */
    'style': string;
    /**
     * 
     * @type {string}
     * @memberof ImageStyle
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface LoginRequest
 */
export interface LoginRequest {
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    'otp'?: string;
}
/**
 * 
 * @export
 * @interface NotifyExternalAuthenticationAttemptParams
 */
export interface NotifyExternalAuthenticationAttemptParams {
    /**
     * 
     * @type {string}
     * @memberof NotifyExternalAuthenticationAttemptParams
     */
    'paymentMethodId': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof NotifyExternalAuthenticationAttemptParams
     */
    'reason': { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface NotifyTransactionExternalAuthenticationAttemptParams
 */
export interface NotifyTransactionExternalAuthenticationAttemptParams {
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof NotifyTransactionExternalAuthenticationAttemptParams
     */
    'reason': { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface OccupationInfo
 */
export interface OccupationInfo {
    /**
     * 
     * @type {number}
     * @memberof OccupationInfo
     */
    'availableAmount': number | null;
    /**
     * 
     * @type {number}
     * @memberof OccupationInfo
     */
    'occupationRate': number | null;
}
/**
 * 
 * @export
 * @interface OccupationRate
 */
export interface OccupationRate {
    /**
     * 
     * @type {OccupationInfo}
     * @memberof OccupationRate
     */
    'quantity'?: OccupationInfo;
    /**
     * 
     * @type {Array<TariffQuantity>}
     * @memberof OccupationRate
     */
    'tariffQuantities'?: Array<TariffQuantity> | null;
    /**
     * 
     * @type {Array<AdditionalQuantity>}
     * @memberof OccupationRate
     */
    'additionalQuantities'?: Array<AdditionalQuantity> | null;
    /**
     * 
     * @type {Array<DateAndTimeScheduleQuantity>}
     * @memberof OccupationRate
     */
    'scheduleQuantities'?: Array<DateAndTimeScheduleQuantity> | null;
    /**
     * 
     * @type {Array<DateAndTimeTariffScheduleQuantity>}
     * @memberof OccupationRate
     */
    'tariffScheduleQuantities'?: Array<DateAndTimeTariffScheduleQuantity> | null;
    /**
     * 
     * @type {Array<DateAndTimeAdditionalScheduleQuantity>}
     * @memberof OccupationRate
     */
    'additionalScheduleQuantities'?: Array<DateAndTimeAdditionalScheduleQuantity> | null;
}
/**
 * 
 * @export
 * @interface Order
 */
export interface Order {
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'code': string;
    /**
     * 
     * @type {OrderStatus}
     * @memberof Order
     */
    'status': OrderStatus;
    /**
     * 
     * @type {number}
     * @memberof Order
     * @deprecated
     */
    'fullAmountCents': number;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof Order
     */
    'fullAmountCurrencyInfo': CurrencyInfo;
    /**
     * 
     * @type {number}
     * @memberof Order
     * @deprecated
     */
    'partialAmountCents': number;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof Order
     */
    'partialAmountCurrencyInfo': CurrencyInfo;
    /**
     * 
     * @type {number}
     * @memberof Order
     * @deprecated
     */
    'finalAmountCents': number;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof Order
     */
    'finalAmountCurrencyInfo': CurrencyInfo;
    /**
     * 
     * @type {boolean}
     * @memberof Order
     */
    'isPayable': boolean;
    /**
     * 
     * @type {Transaction}
     * @memberof Order
     */
    'lastTransaction': Transaction | null;
    /**
     * 
     * @type {Array<Sale>}
     * @memberof Order
     */
    'sales': Array<Sale>;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'directLinkId': string | null;
    /**
     * 
     * @type {DirectLink}
     * @memberof Order
     */
    'directLink': DirectLink | null;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'expiresAt': string | null;
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    'serviceFeeAmountCents': number | null;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof Order
     */
    'serviceFeeCurrencyInfo': CurrencyInfo | null;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'createdAt': string;
}


/**
 * Lifecycle status of an order. `awaiting_confirmation` means the order holds at least one product that must be confirmed by an external system before the buyer can pay. Poll `GET /orders/{orderId}` until the status leaves `awaiting_confirmation`: `created` means the buyer may proceed to payment, `canceled` means the confirmation was refused. The order `expiresAt` still bounds the whole wait.
 * @export
 * @enum {string}
 */

export const OrderStatus = {
    AwaitingConfirmation: 'awaiting_confirmation',
    Created: 'created',
    Expired: 'expired',
    Confirmed: 'confirmed',
    PaymentVoided: 'payment_voided',
    PaymentChargedBack: 'payment_charged_back',
    Canceled: 'canceled'
} as const;

export type OrderStatus = typeof OrderStatus[keyof typeof OrderStatus];


/**
 * 
 * @export
 * @interface PaymentAuthSettings
 */
export interface PaymentAuthSettings {
    /**
     * 
     * @type {PaymentAuthSettingsExecutionRule}
     * @memberof PaymentAuthSettings
     */
    'executionRule': PaymentAuthSettingsExecutionRule;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const PaymentAuthSettingsExecutionRule = {
    Always: 'always',
    AfterAntifraudFailure: 'after_antifraud_failure'
} as const;

export type PaymentAuthSettingsExecutionRule = typeof PaymentAuthSettingsExecutionRule[keyof typeof PaymentAuthSettingsExecutionRule];


/**
 * 
 * @export
 * @interface PaymentBrand
 */
export interface PaymentBrand {
    /**
     * 
     * @type {string}
     * @memberof PaymentBrand
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface PaymentCardParams
 */
export interface PaymentCardParams {
    /**
     * 
     * @type {string}
     * @memberof PaymentCardParams
     */
    'cardNumber': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentCardParams
     */
    'holder': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentCardParams
     */
    'holderIdentity': string | null;
    /**
     * 
     * @type {number}
     * @memberof PaymentCardParams
     */
    'installments': number;
    /**
     * 
     * @type {string}
     * @memberof PaymentCardParams
     */
    'securityCode': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentCardParams
     */
    'validityMonth': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentCardParams
     */
    'validityYear': string;
    /**
     * Use billingAddress instead
     * @type {string}
     * @memberof PaymentCardParams
     * @deprecated
     */
    'postalCode'?: string | null;
    /**
     * 
     * @type {Address}
     * @memberof PaymentCardParams
     */
    'billingAddress'?: Address | null;
}
/**
 * 
 * @export
 * @interface PaymentFingerprint
 */
export interface PaymentFingerprint {
    /**
     * 
     * @type {string}
     * @memberof PaymentFingerprint
     */
    'type': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof PaymentFingerprint
     */
    'data': { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface PaymentInstallmentOption
 */
export interface PaymentInstallmentOption {
    /**
     * 
     * @type {string}
     * @memberof PaymentInstallmentOption
     */
    'label': string;
    /**
     * 
     * @type {number}
     * @memberof PaymentInstallmentOption
     */
    'division': number;
    /**
     * 
     * @type {number}
     * @memberof PaymentInstallmentOption
     * @deprecated
     */
    'amountCents': number;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof PaymentInstallmentOption
     */
    'amountCurrencyInfo': CurrencyInfo;
}
/**
 * 
 * @export
 * @interface PaymentMethod
 */
export interface PaymentMethod {
    /**
     * 
     * @type {string}
     * @memberof PaymentMethod
     */
    'id': string;
    /**
     * 
     * @type {PaymentMethodCode}
     * @memberof PaymentMethod
     */
    'code': PaymentMethodCode;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethod
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof PaymentMethod
     */
    'discountPercentage': number | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const PaymentMethodCode = {
    CreditCard: 'credit_card',
    DebitCard: 'debit_card',
    Pix: 'pix',
    PostPaid: 'post_paid'
} as const;

export type PaymentMethodCode = typeof PaymentMethodCode[keyof typeof PaymentMethodCode];


/**
 * 
 * @export
 * @interface PaymentMethodExternalAuthentication
 */
export interface PaymentMethodExternalAuthentication {
    /**
     * 
     * @type {ExternalAuthenticationProviderType}
     * @memberof PaymentMethodExternalAuthentication
     */
    'type': ExternalAuthenticationProviderType;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof PaymentMethodExternalAuthentication
     */
    'data': { [key: string]: any; };
}


/**
 * 
 * @export
 * @interface PaymentOption
 */
export interface PaymentOption {
    /**
     * 
     * @type {PaymentMethod}
     * @memberof PaymentOption
     */
    'paymentMethod': PaymentMethod;
    /**
     * 
     * @type {string}
     * @memberof PaymentOption
     */
    'softDescriptor': string | null;
    /**
     * 
     * @type {number}
     * @memberof PaymentOption
     * @deprecated
     */
    'amountCents': number;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof PaymentOption
     */
    'amountCurrencyInfo': CurrencyInfo;
    /**
     * 
     * @type {Array<PaymentBrand>}
     * @memberof PaymentOption
     */
    'brands': Array<PaymentBrand> | null;
    /**
     * 
     * @type {Array<PaymentInstallmentOption>}
     * @memberof PaymentOption
     */
    'installmentOptions': Array<PaymentInstallmentOption>;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentOption
     */
    'requiresExternalAuthentication': boolean;
    /**
     * 
     * @type {PaymentMethodExternalAuthentication}
     * @memberof PaymentOption
     */
    'externalAuthentication': PaymentMethodExternalAuthentication | null;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentOption
     */
    'antifraudEnabled': boolean;
    /**
     * 
     * @type {Array<PaymentFingerprint>}
     * @memberof PaymentOption
     */
    'fingerprints': Array<PaymentFingerprint> | null;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentOption
     */
    'needsPhoneVerification': boolean;
    /**
     * 
     * @type {string}
     * @memberof PaymentOption
     */
    'customerMaskedIdentity': string | null;
    /**
     * 
     * @type {PaymentAuthSettings}
     * @memberof PaymentOption
     */
    'paymentAuthSettings': PaymentAuthSettings | null;
}
/**
 * Input types the client must send on the extended GET so RM can compute the final price for this tariff. V1 includes tariff_quantity (tariffId:quantity map in query). 
 * @export
 * @enum {string}
 */

export const PricingInputType = {
    TariffQuantity: 'tariff_quantity'
} as const;

export type PricingInputType = typeof PricingInputType[keyof typeof PricingInputType];


/**
 * 
 * @export
 * @interface Product
 */
export interface Product {
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'appId': string;
    /**
     * 
     * @type {App}
     * @memberof Product
     */
    'app': App;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'active': boolean;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'thumbnailUrl': string | null;
    /**
     * 
     * @type {SellingMode}
     * @memberof Product
     */
    'sellingMode': SellingMode;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'minSaleTariffQuantity': number;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'maxSaleTariffQuantity': number;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'shortDescription': string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'voucherGuidelines': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof Product
     */
    'includeItems': Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof Product
     */
    'notIncludeItems': Array<string> | null;
    /**
     * 
     * @type {Array<ProductHighlight>}
     * @memberof Product
     */
    'highlights': Array<ProductHighlight>;
    /**
     * 
     * @type {ReservationReschedulingSettings}
     * @memberof Product
     */
    'reservationReschedulingSettings': ReservationReschedulingSettings;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'updatedAt': string;
}


/**
 * 
 * @export
 * @interface ProductHighlight
 */
export interface ProductHighlight {
    /**
     * 
     * @type {string}
     * @memberof ProductHighlight
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof ProductHighlight
     */
    'description': string | null;
}
/**
 * 
 * @export
 * @interface ProductImage
 */
export interface ProductImage {
    /**
     * 
     * @type {string}
     * @memberof ProductImage
     */
    'id': string;
    /**
     * 
     * @type {Image}
     * @memberof ProductImage
     */
    'image': Image;
    /**
     * 
     * @type {boolean}
     * @memberof ProductImage
     */
    'active': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductImage
     */
    'thumbnail': boolean;
    /**
     * 
     * @type {string}
     * @memberof ProductImage
     */
    'createdAt': string;
}
/**
 * 
 * @export
 * @interface ProductItineraryMoment
 */
export interface ProductItineraryMoment {
    /**
     * 
     * @type {string}
     * @memberof ProductItineraryMoment
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ProductItineraryMoment
     */
    'productId': string;
    /**
     * 
     * @type {number}
     * @memberof ProductItineraryMoment
     */
    'position': number;
    /**
     * 
     * @type {string}
     * @memberof ProductItineraryMoment
     */
    'moment': string;
    /**
     * 
     * @type {string}
     * @memberof ProductItineraryMoment
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof ProductItineraryMoment
     */
    'description': string | null;
}
/**
 * 
 * @export
 * @interface ProductPackage
 */
export interface ProductPackage {
    /**
     * 
     * @type {string}
     * @memberof ProductPackage
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ProductPackage
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ProductPackage
     */
    'internalName': string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductPackage
     */
    'imageId': string | null;
    /**
     * 
     * @type {Image}
     * @memberof ProductPackage
     */
    'image': Image | null;
    /**
     * 
     * @type {string}
     * @memberof ProductPackage
     */
    'description': string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductPackage
     */
    'shortDescription': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductPackage
     */
    'includedItems': Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductPackage
     */
    'notIncludedItems': Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ProductPackage
     */
    'voucherGuidelines': string | null;
    /**
     * 
     * @type {ProductPackageConfigurationMode}
     * @memberof ProductPackage
     */
    'configurationMode': ProductPackageConfigurationMode;
    /**
     * 
     * @type {string}
     * @memberof ProductPackage
     */
    'deletedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductPackage
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ProductPackage
     */
    'updatedAt': string;
}


/**
 * How the buyer configures the products of the package during checkout. `multi_booking` keeps the current behaviour: the buyer configures date, time, tariff and seats for each product of the package, one at a time. `single_booking` collects date, time and quantity once and replicates the selection to every product of the package. 
 * @export
 * @enum {string}
 */

export const ProductPackageConfigurationMode = {
    MultiBooking: 'multi_booking',
    SingleBooking: 'single_booking'
} as const;

export type ProductPackageConfigurationMode = typeof ProductPackageConfigurationMode[keyof typeof ProductPackageConfigurationMode];


/**
 * 
 * @export
 * @interface ProductPackageProduct
 */
export interface ProductPackageProduct {
    /**
     * 
     * @type {string}
     * @memberof ProductPackageProduct
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ProductPackageProduct
     */
    'productPackageId': string;
    /**
     * 
     * @type {string}
     * @memberof ProductPackageProduct
     */
    'productId': string;
    /**
     * 
     * @type {Product}
     * @memberof ProductPackageProduct
     */
    'product': Product;
    /**
     * 
     * @type {ProductPackage}
     * @memberof ProductPackageProduct
     */
    'productPackage': ProductPackage;
    /**
     * 
     * @type {number}
     * @memberof ProductPackageProduct
     */
    'discountPercentage': number;
    /**
     * 
     * @type {number}
     * @memberof ProductPackageProduct
     */
    'position': number;
    /**
     * 
     * @type {string}
     * @memberof ProductPackageProduct
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ProductPackageProduct
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface RecoverPasswordRequest
 */
export interface RecoverPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof RecoverPasswordRequest
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof RecoverPasswordRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof RecoverPasswordRequest
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface RescheduleChargeSummary
 */
export interface RescheduleChargeSummary {
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof RescheduleChargeSummary
     */
    'originalAmount': CurrencyInfo;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof RescheduleChargeSummary
     */
    'newAmount': CurrencyInfo;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof RescheduleChargeSummary
     */
    'adjustmentAmount': CurrencyInfo;
}
/**
 * 
 * @export
 * @interface RescheduleInfo
 */
export interface RescheduleInfo {
    /**
     * 
     * @type {boolean}
     * @memberof RescheduleInfo
     */
    'canReschedule': boolean;
    /**
     * 
     * @type {string}
     * @memberof RescheduleInfo
     */
    'rescheduleUntil': string | null;
    /**
     * 
     * @type {number}
     * @memberof RescheduleInfo
     */
    'remainingRescheduleCount': number;
    /**
     * 
     * @type {boolean}
     * @memberof RescheduleInfo
     */
    'chargeable': boolean;
}
/**
 * 
 * @export
 * @interface RescheduleSaleItemRequest
 */
export interface RescheduleSaleItemRequest {
    /**
     * 
     * @type {string}
     * @memberof RescheduleSaleItemRequest
     */
    'scheduleDate': string;
    /**
     * 
     * @type {number}
     * @memberof RescheduleSaleItemRequest
     */
    'scheduleTimeMinutes': number | null;
}
/**
 * 
 * @export
 * @interface RescheduleScheduling
 */
export interface RescheduleScheduling {
    /**
     * 
     * @type {string}
     * @memberof RescheduleScheduling
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof RescheduleScheduling
     */
    'date': string;
    /**
     * 
     * @type {number}
     * @memberof RescheduleScheduling
     */
    'consumableFromMinutes': number | null;
    /**
     * 
     * @type {number}
     * @memberof RescheduleScheduling
     */
    'consumableToMinutes': number | null;
    /**
     * 
     * @type {number}
     * @memberof RescheduleScheduling
     */
    'calendarIntervalMinutes': number | null;
    /**
     * 
     * @type {number}
     * @memberof RescheduleScheduling
     */
    'durationMinutes': number;
    /**
     * 
     * @type {number}
     * @memberof RescheduleScheduling
     */
    'antecedenceMinutes': number | null;
    /**
     * 
     * @type {number}
     * @memberof RescheduleScheduling
     */
    'antecedenceHoursReferenceMinutes': number | null;
    /**
     * 
     * @type {Array<ScheduleTime>}
     * @memberof RescheduleScheduling
     */
    'availableScheduleTimes': Array<ScheduleTime> | null;
    /**
     * 
     * @type {Array<RescheduleSchedulingAvailability>}
     * @memberof RescheduleScheduling
     */
    'scheduleAvailabilities': Array<RescheduleSchedulingAvailability>;
    /**
     * 
     * @type {TariffGroup}
     * @memberof RescheduleScheduling
     */
    'finalTariffGroup': TariffGroup;
    /**
     * 
     * @type {Array<TariffScheduleUnitPrice>}
     * @memberof RescheduleScheduling
     */
    'tariffScheduleUnitPrices': Array<TariffScheduleUnitPrice>;
}
/**
 * 
 * @export
 * @interface RescheduleSchedulingAvailability
 */
export interface RescheduleSchedulingAvailability {
    /**
     * 
     * @type {string}
     * @memberof RescheduleSchedulingAvailability
     */
    'time': string | null;
    /**
     * 
     * @type {number}
     * @memberof RescheduleSchedulingAvailability
     */
    'minutes': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof RescheduleSchedulingAvailability
     */
    'available': boolean;
}
/**
 * 
 * @export
 * @interface ReservationReschedulingSettings
 */
export interface ReservationReschedulingSettings {
    /**
     * 
     * @type {boolean}
     * @memberof ReservationReschedulingSettings
     */
    'allowRescheduling': boolean;
    /**
     * 
     * @type {number}
     * @memberof ReservationReschedulingSettings
     */
    'maxReschedulingCount': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReservationReschedulingSettings
     */
    'allowReschedulingToHigherTariffPrice': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReservationReschedulingSettings
     */
    'allowReschedulingToLowerTariffPrice': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReservationReschedulingSettings
     */
    'chargeRescheduleToHigherPrice': boolean;
    /**
     * 
     * @type {number}
     * @memberof ReservationReschedulingSettings
     */
    'reschedulingAntecedenceMinutes': number | null;
}
/**
 * 
 * @export
 * @interface ResetPasswordRequest
 */
export interface ResetPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordRequest
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface Resource
 */
export interface Resource {
    /**
     * 
     * @type {string}
     * @memberof Resource
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Resource
     */
    'code': string | null;
    /**
     * 
     * @type {string}
     * @memberof Resource
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Resource
     */
    'formattedName': string;
    /**
     * 
     * @type {number}
     * @memberof Resource
     */
    'capacity': number;
}
/**
 * 
 * @export
 * @interface ResourceCategory
 */
export interface ResourceCategory {
    /**
     * 
     * @type {string}
     * @memberof ResourceCategory
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ResourceCategory
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ResourceCategory
     */
    'completeCapacityChargeType': ResourceCategoryCompleteCapacityChargeTypeEnum | null;
    /**
     * 
     * @type {number}
     * @memberof ResourceCategory
     * @deprecated
     */
    'minCapacityUnitCents': number | null;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof ResourceCategory
     */
    'minCapacityUnitCurrencyInfo': CurrencyInfo | null;
    /**
     * 
     * @type {number}
     * @memberof ResourceCategory
     */
    'minCapacityPercent': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResourceCategory
     */
    'allowUnderAllocation': boolean;
    /**
     * 
     * @type {number}
     * @memberof ResourceCategory
     */
    'tariffPercentage': number | null;
    /**
     * 
     * @type {Tariff}
     * @memberof ResourceCategory
     */
    'tariff': Tariff | null;
    /**
     * 
     * @type {string}
     * @memberof ResourceCategory
     */
    'color': string;
    /**
     * 
     * @type {boolean}
     * @memberof ResourceCategory
     */
    'blocked': boolean;
}

export const ResourceCategoryCompleteCapacityChargeTypeEnum = {
    FixedValue: 'fixed_value',
    TariffPercent: 'tariff_percent'
} as const;

export type ResourceCategoryCompleteCapacityChargeTypeEnum = typeof ResourceCategoryCompleteCapacityChargeTypeEnum[keyof typeof ResourceCategoryCompleteCapacityChargeTypeEnum];

/**
 * 
 * @export
 * @interface Sale
 */
export interface Sale {
    /**
     * 
     * @type {string}
     * @memberof Sale
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Sale
     */
    'code': string | null;
    /**
     * 
     * @type {number}
     * @memberof Sale
     */
    'position': number;
    /**
     * 
     * @type {SaleState}
     * @memberof Sale
     */
    'state': SaleState;
    /**
     * 
     * @type {number}
     * @memberof Sale
     * @deprecated
     */
    'partialAmountCents': number;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof Sale
     */
    'partialAmountCurrencyInfo': CurrencyInfo;
    /**
     * 
     * @type {number}
     * @memberof Sale
     * @deprecated
     */
    'totalAmountCents': number;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof Sale
     */
    'totalAmountCurrencyInfo': CurrencyInfo;
    /**
     * 
     * @type {boolean}
     * @memberof Sale
     */
    'isPayable': boolean;
    /**
     * 
     * @type {Transaction}
     * @memberof Sale
     */
    'lastTransaction': Transaction | null;
    /**
     * 
     * @type {SaleCoupon}
     * @memberof Sale
     */
    'coupon': SaleCoupon | null;
    /**
     * 
     * @type {Array<DetailedSaleItem>}
     * @memberof Sale
     */
    'items': Array<DetailedSaleItem>;
    /**
     * 
     * @type {string}
     * @memberof Sale
     */
    'directLinkId': string | null;
    /**
     * 
     * @type {DirectLink}
     * @memberof Sale
     */
    'directLink': DirectLink | null;
    /**
     * 
     * @type {number}
     * @memberof Sale
     */
    'serviceFeeAmountCents': number | null;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof Sale
     */
    'serviceFeeCurrencyInfo': CurrencyInfo | null;
    /**
     * 
     * @type {string}
     * @memberof Sale
     */
    'createdAt': string;
}


/**
 * 
 * @export
 * @interface SaleAdditional
 */
export interface SaleAdditional {
    /**
     * 
     * @type {string}
     * @memberof SaleAdditional
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof SaleAdditional
     * @deprecated
     */
    'unitPriceCents': number;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof SaleAdditional
     */
    'unitPriceCurrencyInfo': CurrencyInfo;
    /**
     * 
     * @type {number}
     * @memberof SaleAdditional
     * @deprecated
     */
    'priceCents': number;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof SaleAdditional
     */
    'priceCurrencyInfo': CurrencyInfo;
    /**
     * 
     * @type {number}
     * @memberof SaleAdditional
     */
    'unitQuantity': number;
    /**
     * 
     * @type {SaleAdditionalData}
     * @memberof SaleAdditional
     */
    'data': SaleAdditionalData;
    /**
     * 
     * @type {Additional}
     * @memberof SaleAdditional
     */
    'additional': Additional;
}
/**
 * 
 * @export
 * @interface SaleAdditionalData
 */
export interface SaleAdditionalData {
    /**
     * 
     * @type {string}
     * @memberof SaleAdditionalData
     */
    'inputLabel': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaleAdditionalData
     */
    'inputValue': string | null;
}
/**
 * 
 * @export
 * @interface SaleChange
 */
export interface SaleChange {
    /**
     * 
     * @type {string}
     * @memberof SaleChange
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SaleChange
     */
    'saleId': string;
    /**
     * 
     * @type {SaleChangeTypeEnum}
     * @memberof SaleChange
     */
    'type': SaleChangeTypeEnum;
    /**
     * 
     * @type {SaleChangeStatusEnum}
     * @memberof SaleChange
     */
    'status': SaleChangeStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof SaleChange
     */
    'saleItemId': string | null;
    /**
     * 
     * @type {SaleItem}
     * @memberof SaleChange
     */
    'saleItem': SaleItem | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaleChange
     */
    'isPayable': boolean;
    /**
     * 
     * @type {Transaction}
     * @memberof SaleChange
     */
    'lastTransaction': Transaction | null;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof SaleChange
     */
    'updatedSaleAmount': CurrencyInfo;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof SaleChange
     */
    'amount': CurrencyInfo;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof SaleChange
     */
    'finalAmount': CurrencyInfo;
    /**
     * 
     * @type {SaleChangeMetadata}
     * @memberof SaleChange
     */
    'metadata': SaleChangeMetadata | null;
    /**
     * 
     * @type {string}
     * @memberof SaleChange
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof SaleChange
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof SaleChange
     */
    'expiresAt': string | null;
}


/**
 * Structured metadata for sale change (patch up/down).
 * @export
 * @interface SaleChangeMetadata
 */
export interface SaleChangeMetadata {
    /**
     * 
     * @type {SaleChangeOperationsMetadata}
     * @memberof SaleChangeMetadata
     */
    'up': SaleChangeOperationsMetadata;
    /**
     * 
     * @type {SaleChangeOperationsMetadata}
     * @memberof SaleChangeMetadata
     */
    'down': SaleChangeOperationsMetadata;
}
/**
 * Up or down side of the change (new state or old state).
 * @export
 * @interface SaleChangeOperationsMetadata
 */
export interface SaleChangeOperationsMetadata {
    /**
     * 
     * @type {SaleChangePatchMetadata}
     * @memberof SaleChangeOperationsMetadata
     */
    'patch': SaleChangePatchMetadata | null;
}
/**
 * 
 * @export
 * @interface SaleChangePatchMetadata
 */
export interface SaleChangePatchMetadata {
    /**
     * Map of sale item id (string) to patch payload.
     * @type {{ [key: string]: SaleItemPatchMetadata; }}
     * @memberof SaleChangePatchMetadata
     */
    'items': { [key: string]: SaleItemPatchMetadata; };
}
/**
 * 
 * @export
 * @enum {string}
 */

export const SaleChangeStatusEnum = {
    Pending: 'pending',
    Applied: 'applied',
    Expired: 'expired',
    Canceled: 'canceled'
} as const;

export type SaleChangeStatusEnum = typeof SaleChangeStatusEnum[keyof typeof SaleChangeStatusEnum];


/**
 * Tariff reference and quantity for a sale item patch.
 * @export
 * @interface SaleChangeTariffMetadata
 */
export interface SaleChangeTariffMetadata {
    /**
     * 
     * @type {string}
     * @memberof SaleChangeTariffMetadata
     */
    'tariffId': string;
    /**
     * 
     * @type {number}
     * @memberof SaleChangeTariffMetadata
     */
    'quantity': number;
    /**
     * 
     * @type {number}
     * @memberof SaleChangeTariffMetadata
     */
    'unitPriceCents': number;
    /**
     * 
     * @type {number}
     * @memberof SaleChangeTariffMetadata
     */
    'originalPriceCents': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const SaleChangeTypeEnum = {
    Creation: 'creation',
    Reschedule: 'reschedule'
} as const;

export type SaleChangeTypeEnum = typeof SaleChangeTypeEnum[keyof typeof SaleChangeTypeEnum];


/**
 * 
 * @export
 * @interface SaleCoupon
 */
export interface SaleCoupon {
    /**
     * 
     * @type {string}
     * @memberof SaleCoupon
     */
    'formattedDiscount': string;
    /**
     * 
     * @type {number}
     * @memberof SaleCoupon
     * @deprecated
     */
    'fullAmountCents': number;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof SaleCoupon
     */
    'fullAmountCurrencyInfo': CurrencyInfo;
    /**
     * 
     * @type {number}
     * @memberof SaleCoupon
     * @deprecated
     */
    'finalAmountCents': number;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof SaleCoupon
     */
    'finalAmountCurrencyInfo': CurrencyInfo;
    /**
     * 
     * @type {string}
     * @memberof SaleCoupon
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof SaleCoupon
     */
    'type': SaleCouponTypeEnum;
    /**
     * 
     * @type {CouponUsageType}
     * @memberof SaleCoupon
     */
    'usageType': CouponUsageType;
    /**
     * 
     * @type {string}
     * @memberof SaleCoupon
     */
    'constraintType': SaleCouponConstraintTypeEnum | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SaleCoupon
     */
    'productIds': Array<string> | null;
}

export const SaleCouponTypeEnum = {
    Nominal: 'nominal',
    Percentage: 'percentage'
} as const;

export type SaleCouponTypeEnum = typeof SaleCouponTypeEnum[keyof typeof SaleCouponTypeEnum];
export const SaleCouponConstraintTypeEnum = {
    Include: 'include',
    Exclude: 'exclude'
} as const;

export type SaleCouponConstraintTypeEnum = typeof SaleCouponConstraintTypeEnum[keyof typeof SaleCouponConstraintTypeEnum];

/**
 * 
 * @export
 * @interface SaleFormInput
 */
export interface SaleFormInput {
    /**
     * 
     * @type {string}
     * @memberof SaleFormInput
     */
    'saleId': string | null;
    /**
     * 
     * @type {FormInput}
     * @memberof SaleFormInput
     */
    'formInput': FormInput;
    /**
     * 
     * @type {FormInputType}
     * @memberof SaleFormInput
     */
    'type': FormInputType;
    /**
     * 
     * @type {FormInputInputType}
     * @memberof SaleFormInput
     */
    'inputType': FormInputInputType;
    /**
     * 
     * @type {Array<string>}
     * @memberof SaleFormInput
     */
    'validationRules': Array<string> | null;
    /**
     * 
     * @type {SaleTariff}
     * @memberof SaleFormInput
     */
    'saleTariff': SaleTariff | null;
    /**
     * 
     * @type {number}
     * @memberof SaleFormInput
     */
    'number': number | null;
    /**
     * 
     * @type {string}
     * @memberof SaleFormInput
     */
    'hash': string;
    /**
     * 
     * @type {string}
     * @memberof SaleFormInput
     */
    'value': string;
}


/**
 * 
 * @export
 * @interface SaleFormInputRequest
 */
export interface SaleFormInputRequest {
    /**
     * 
     * @type {string}
     * @memberof SaleFormInputRequest
     */
    'hash': string;
    /**
     * 
     * @type {string}
     * @memberof SaleFormInputRequest
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface SaleItem
 */
export interface SaleItem {
    /**
     * 
     * @type {string}
     * @memberof SaleItem
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SaleItem
     */
    'scheduleDate': string | null;
    /**
     * 
     * @type {number}
     * @memberof SaleItem
     */
    'scheduleTimeMinutes': number | null;
    /**
     * 
     * @type {string}
     * @memberof SaleItem
     */
    'formattedScheduleTimeMinutes': string | null;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof SaleItem
     */
    'totalPriceCurrencyInfo': CurrencyInfo;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof SaleItem
     */
    'basePriceCurrencyInfo': CurrencyInfo;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof SaleItem
     */
    'fullPriceCurrencyInfo': CurrencyInfo;
    /**
     * 
     * @type {Product}
     * @memberof SaleItem
     */
    'product': Product;
    /**
     * 
     * @type {string}
     * @memberof SaleItem
     */
    'productPackageUnitId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaleItem
     */
    'productPackageProductId': string | null;
    /**
     * 
     * @type {ProductPackageProduct}
     * @memberof SaleItem
     */
    'productPackageProduct': ProductPackageProduct | null;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof SaleItem
     */
    'productPackageOriginalDiscountCurrencyInfo': CurrencyInfo | null;
    /**
     * 
     * @type {string}
     * @memberof SaleItem
     */
    'serviceFeeId': string | null;
    /**
     * 
     * @type {ServiceFee}
     * @memberof SaleItem
     */
    'serviceFee': ServiceFee | null;
    /**
     * 
     * @type {ServiceFeeTypeEnum}
     * @memberof SaleItem
     */
    'serviceFeeType': ServiceFeeTypeEnum | null;
    /**
     * 
     * @type {number}
     * @memberof SaleItem
     */
    'serviceFeePercentage': number | null;
    /**
     * 
     * @type {number}
     * @memberof SaleItem
     */
    'serviceFeeAmountCents': number | null;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof SaleItem
     */
    'serviceFeeCurrencyInfo': CurrencyInfo | null;
    /**
     * Identifier of the upsell offer that originated this sale item. Propagated from the cart item on checkout.
     * @type {string}
     * @memberof SaleItem
     */
    'upsellOfferId': string | null;
    /**
     * 
     * @type {Array<SelectedTariffGroupAttributes>}
     * @memberof SaleItem
     */
    'selectedAttributes'?: Array<SelectedTariffGroupAttributes> | null;
    /**
     * 
     * @type {string}
     * @memberof SaleItem
     */
    'reservationId': string | null;
}


/**
 * Patch payload for a sale item (schedule and tariffs; prices are derived by the domain).
 * @export
 * @interface SaleItemPatchMetadata
 */
export interface SaleItemPatchMetadata {
    /**
     * Date only (YYYY-MM-DD).
     * @type {string}
     * @memberof SaleItemPatchMetadata
     */
    'scheduleDate': string;
    /**
     * Minutes from midnight (0-1439). Optional.
     * @type {number}
     * @memberof SaleItemPatchMetadata
     */
    'scheduleTimeMinutes': number | null;
    /**
     * Duration in minutes.
     * @type {number}
     * @memberof SaleItemPatchMetadata
     */
    'durationMinutes': number | null;
    /**
     * Price in cents.
     * @type {number}
     * @memberof SaleItemPatchMetadata
     */
    'priceCents': number;
    /**
     * Full price in cents (base plus service fee when applicable).
     * @type {number}
     * @memberof SaleItemPatchMetadata
     */
    'fullPriceCents': number;
    /**
     * Tariffs, resources, and add-ons subtotal in cents before service fee.
     * @type {number}
     * @memberof SaleItemPatchMetadata
     */
    'basePriceCents': number;
    /**
     * Map of sale tariff id (string) to tariff patch.
     * @type {{ [key: string]: SaleChangeTariffMetadata; }}
     * @memberof SaleItemPatchMetadata
     */
    'tariffs': { [key: string]: SaleChangeTariffMetadata; };
}
/**
 * 
 * @export
 * @interface SaleOrigin
 */
export interface SaleOrigin {
    /**
     * 
     * @type {string}
     * @memberof SaleOrigin
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface SaleResource
 */
export interface SaleResource {
    /**
     * 
     * @type {string}
     * @memberof SaleResource
     */
    'id': string;
    /**
     * 
     * @type {Array<SaleResourceQuantity>}
     * @memberof SaleResource
     */
    'quantities': Array<SaleResourceQuantity>;
    /**
     * 
     * @type {number}
     * @memberof SaleResource
     * @deprecated
     */
    'priceCents': number;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof SaleResource
     */
    'priceCurrencyInfo': CurrencyInfo;
    /**
     * 
     * @type {Resource}
     * @memberof SaleResource
     */
    'resource': Resource;
}
/**
 * 
 * @export
 * @interface SaleResourceQuantity
 */
export interface SaleResourceQuantity {
    /**
     * 
     * @type {string}
     * @memberof SaleResourceQuantity
     */
    'tariffId': string;
    /**
     * 
     * @type {number}
     * @memberof SaleResourceQuantity
     */
    'quantity': number;
}
/**
 * Lifecycle state of a sale. `awaiting_confirmation` means the sale is waiting to be confirmed by an external system; once confirmed it resumes the lifecycle where it would have been without the gate. It is unrelated to `pending`, which means the payment is pending.
 * @export
 * @enum {string}
 */

export const SaleState = {
    AwaitingConfirmation: 'awaiting_confirmation',
    Created: 'created',
    Pending: 'pending',
    PaymentComplete: 'payment_complete',
    Expired: 'expired',
    PaymentVoided: 'payment_voided',
    PaymentChargeback: 'payment_chargeback',
    PaymentDenied: 'payment_denied',
    Canceled: 'canceled'
} as const;

export type SaleState = typeof SaleState[keyof typeof SaleState];


/**
 * 
 * @export
 * @interface SaleTariff
 */
export interface SaleTariff {
    /**
     * 
     * @type {string}
     * @memberof SaleTariff
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SaleTariff
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof SaleTariff
     */
    'quantity': number;
    /**
     * 
     * @type {number}
     * @memberof SaleTariff
     * @deprecated
     */
    'unitPriceCents': number;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof SaleTariff
     */
    'unitPriceCurrencyInfo': CurrencyInfo;
    /**
     * 
     * @type {string}
     * @memberof SaleTariff
     */
    'tariffId': string;
    /**
     * 
     * @type {Tariff}
     * @memberof SaleTariff
     */
    'tariff': Tariff;
}
/**
 * 
 * @export
 * @interface ScheduleTime
 */
export interface ScheduleTime {
    /**
     * 
     * @type {number}
     * @memberof ScheduleTime
     */
    'minutes': number;
    /**
     * 
     * @type {string}
     * @memberof ScheduleTime
     */
    'formattedTime': string;
}
/**
 * 
 * @export
 * @interface Scheduling
 */
export interface Scheduling {
    /**
     * 
     * @type {string}
     * @memberof Scheduling
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Scheduling
     */
    'date': string;
    /**
     * 
     * @type {number}
     * @memberof Scheduling
     */
    'consumableFromMinutes': number | null;
    /**
     * 
     * @type {number}
     * @memberof Scheduling
     */
    'consumableToMinutes': number | null;
    /**
     * 
     * @type {number}
     * @memberof Scheduling
     */
    'calendarIntervalMinutes': number | null;
    /**
     * 
     * @type {number}
     * @memberof Scheduling
     */
    'durationMinutes': number;
    /**
     * 
     * @type {number}
     * @memberof Scheduling
     */
    'antecedenceMinutes': number | null;
    /**
     * 
     * @type {number}
     * @memberof Scheduling
     */
    'antecedenceHoursReferenceMinutes': number | null;
    /**
     * 
     * @type {Array<ScheduleTime>}
     * @memberof Scheduling
     */
    'availableScheduleTimes': Array<ScheduleTime> | null;
    /**
     * 
     * @type {TariffGroup}
     * @memberof Scheduling
     */
    'tariffGroup': TariffGroup;
    /**
     * 
     * @type {OccupationRate}
     * @memberof Scheduling
     */
    'occupationRates': OccupationRate;
    /**
     * 
     * @type {boolean}
     * @memberof Scheduling
     */
    'requiresSeatSelection': boolean;
    /**
     * 
     * @type {Array<TariffScheduleUnitPrice>}
     * @memberof Scheduling
     */
    'tariffScheduleUnitPrices': Array<TariffScheduleUnitPrice>;
}
/**
 * 
 * @export
 * @interface SeatMapArea
 */
export interface SeatMapArea {
    /**
     * 
     * @type {string}
     * @memberof SeatMapArea
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SeatMapArea
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof SeatMapArea
     */
    'width': number;
    /**
     * 
     * @type {number}
     * @memberof SeatMapArea
     */
    'height': number;
    /**
     * 
     * @type {string}
     * @memberof SeatMapArea
     */
    'bgImageUrl': string | null;
    /**
     * 
     * @type {Array<SeatMapSlot>}
     * @memberof SeatMapArea
     */
    'slots': Array<SeatMapSlot>;
}
/**
 * 
 * @export
 * @interface SeatMapOverview
 */
export interface SeatMapOverview {
    /**
     * 
     * @type {string}
     * @memberof SeatMapOverview
     */
    'id': string;
    /**
     * 
     * @type {Array<ResourceCategory>}
     * @memberof SeatMapOverview
     */
    'categories': Array<ResourceCategory>;
    /**
     * 
     * @type {Array<SeatMapArea>}
     * @memberof SeatMapOverview
     */
    'areas': Array<SeatMapArea>;
}
/**
 * 
 * @export
 * @interface SeatMapSlot
 */
export interface SeatMapSlot {
    /**
     * 
     * @type {string}
     * @memberof SeatMapSlot
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SeatMapSlot
     */
    'type': SeatMapSlotTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SeatMapSlot
     */
    'shapeType': SeatMapSlotShapeTypeEnum;
    /**
     * 
     * @type {SeatMapSlotRect}
     * @memberof SeatMapSlot
     */
    'rect': SeatMapSlotRect | null;
    /**
     * 
     * @type {SeatMapSlotCircle}
     * @memberof SeatMapSlot
     */
    'circle': SeatMapSlotCircle | null;
    /**
     * 
     * @type {SeatMapSlotResource}
     * @memberof SeatMapSlot
     */
    'resource': SeatMapSlotResource;
}

export const SeatMapSlotTypeEnum = {
    Resource: 'resource'
} as const;

export type SeatMapSlotTypeEnum = typeof SeatMapSlotTypeEnum[keyof typeof SeatMapSlotTypeEnum];
export const SeatMapSlotShapeTypeEnum = {
    Rect: 'rect',
    Circle: 'circle'
} as const;

export type SeatMapSlotShapeTypeEnum = typeof SeatMapSlotShapeTypeEnum[keyof typeof SeatMapSlotShapeTypeEnum];

/**
 * 
 * @export
 * @interface SeatMapSlotCircle
 */
export interface SeatMapSlotCircle {
    /**
     * 
     * @type {number}
     * @memberof SeatMapSlotCircle
     */
    'top': number;
    /**
     * 
     * @type {number}
     * @memberof SeatMapSlotCircle
     */
    'left': number;
    /**
     * 
     * @type {number}
     * @memberof SeatMapSlotCircle
     */
    'radius': number;
}
/**
 * 
 * @export
 * @interface SeatMapSlotRect
 */
export interface SeatMapSlotRect {
    /**
     * 
     * @type {number}
     * @memberof SeatMapSlotRect
     */
    'top': number;
    /**
     * 
     * @type {number}
     * @memberof SeatMapSlotRect
     */
    'left': number;
    /**
     * 
     * @type {number}
     * @memberof SeatMapSlotRect
     */
    'angle': number;
    /**
     * 
     * @type {number}
     * @memberof SeatMapSlotRect
     */
    'width': number;
    /**
     * 
     * @type {number}
     * @memberof SeatMapSlotRect
     */
    'height': number;
}
/**
 * 
 * @export
 * @interface SeatMapSlotResource
 */
export interface SeatMapSlotResource {
    /**
     * 
     * @type {string}
     * @memberof SeatMapSlotResource
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SeatMapSlotResource
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SeatMapSlotResource
     */
    'code': string | null;
    /**
     * 
     * @type {number}
     * @memberof SeatMapSlotResource
     */
    'capacity': number;
    /**
     * 
     * @type {boolean}
     * @memberof SeatMapSlotResource
     */
    'taken': boolean;
    /**
     * 
     * @type {string}
     * @memberof SeatMapSlotResource
     */
    'categoryId': string;
}
/**
 * 
 * @export
 * @interface SelectedTariffGroupAttributes
 */
export interface SelectedTariffGroupAttributes {
    /**
     * 
     * @type {TariffGroupAttributeTypeEnum}
     * @memberof SelectedTariffGroupAttributes
     */
    'type': TariffGroupAttributeTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SelectedTariffGroupAttributes
     */
    'value': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const SellingMode = {
    WithDateAndTime: 'with_date_and_time',
    WithDateOnly: 'with_date_only',
    WithoutDate: 'without_date'
} as const;

export type SellingMode = typeof SellingMode[keyof typeof SellingMode];


/**
 * 
 * @export
 * @interface SendOtpRequest
 */
export interface SendOtpRequest {
    /**
     * 
     * @type {string}
     * @memberof SendOtpRequest
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface ServiceFee
 */
export interface ServiceFee {
    /**
     * 
     * @type {string}
     * @memberof ServiceFee
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ServiceFee
     */
    'description': string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ServiceFeeTypeEnum = {
    PercentageFee: 'percentage_fee',
    AmountCents: 'amount_cents'
} as const;

export type ServiceFeeTypeEnum = typeof ServiceFeeTypeEnum[keyof typeof ServiceFeeTypeEnum];


/**
 * 
 * @export
 * @interface SetCartAffiliationRequest
 */
export interface SetCartAffiliationRequest {
    /**
     * 
     * @type {string}
     * @memberof SetCartAffiliationRequest
     */
    'affiliationCode': string;
}
/**
 * 
 * @export
 * @interface SetCartCouponRequest
 */
export interface SetCartCouponRequest {
    /**
     * 
     * @type {string}
     * @memberof SetCartCouponRequest
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface SetCartSaleOriginRequest
 */
export interface SetCartSaleOriginRequest {
    /**
     * 
     * @type {string}
     * @memberof SetCartSaleOriginRequest
     */
    'saleOriginCode': string;
}
/**
 * 
 * @export
 * @interface SetRequiredFormInputsRequest
 */
export interface SetRequiredFormInputsRequest {
    /**
     * 
     * @type {Array<SaleFormInputRequest>}
     * @memberof SetRequiredFormInputsRequest
     */
    'inputs': Array<SaleFormInputRequest>;
}
/**
 * 
 * @export
 * @interface SignupRequest
 */
export interface SignupRequest {
    /**
     * 
     * @type {boolean}
     * @memberof SignupRequest
     */
    'agreesToTerms': boolean;
    /**
     * 
     * @type {string}
     * @memberof SignupRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof SignupRequest
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof SignupRequest
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof SignupRequest
     */
    'corporateName': string | null;
    /**
     * 
     * @type {string}
     * @memberof SignupRequest
     */
    'countryCode': string | null;
    /**
     * 
     * @type {string}
     * @memberof SignupRequest
     */
    'identityType': string;
    /**
     * 
     * @type {string}
     * @memberof SignupRequest
     */
    'identity': string;
    /**
     * 
     * @type {string}
     * @memberof SignupRequest
     */
    'birthdate': string | null;
    /**
     * 
     * @type {Address}
     * @memberof SignupRequest
     */
    'address': Address | null;
    /**
     * 
     * @type {string}
     * @memberof SignupRequest
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof SignupRequest
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof SignupRequest
     */
    'recaptchaToken': string | null;
}
/**
 * 
 * @export
 * @interface Tariff
 */
export interface Tariff {
    /**
     * 
     * @type {string}
     * @memberof Tariff
     */
    'id': string;
    /**
     * 
     * @type {TariffType}
     * @memberof Tariff
     */
    'type': TariffType;
    /**
     * 
     * @type {number}
     * @memberof Tariff
     * @deprecated
     */
    'priceCents': number;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof Tariff
     */
    'priceCurrencyInfo': CurrencyInfo;
    /**
     * 
     * @type {number}
     * @memberof Tariff
     * @deprecated
     */
    'oldPriceCents': number | null;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof Tariff
     */
    'oldPriceCurrencyInfo': CurrencyInfo | null;
    /**
     * 
     * @type {boolean}
     * @memberof Tariff
     */
    'isDependent': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Tariff
     */
    'isDefault': boolean;
    /**
     * 
     * @type {string}
     * @memberof Tariff
     */
    'description': string | null;
}
/**
 * 
 * @export
 * @interface TariffGroup
 */
export interface TariffGroup {
    /**
     * 
     * @type {string}
     * @memberof TariffGroup
     */
    'id': string;
    /**
     * 
     * @type {Array<Tariff>}
     * @memberof TariffGroup
     */
    'tariffs': Array<Tariff>;
    /**
     * 
     * @type {string}
     * @memberof TariffGroup
     */
    'serviceFeeId': string | null;
    /**
     * 
     * @type {ServiceFee}
     * @memberof TariffGroup
     */
    'serviceFee': ServiceFee | null;
}
/**
 * 
 * @export
 * @interface TariffGroupAttribute
 */
export interface TariffGroupAttribute {
    /**
     * 
     * @type {string}
     * @memberof TariffGroupAttribute
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TariffGroupAttribute
     */
    'tariffGroupId': string;
    /**
     * 
     * @type {TariffGroupAttributeTypeEnum}
     * @memberof TariffGroupAttribute
     */
    'type': TariffGroupAttributeTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof TariffGroupAttribute
     */
    'value': string;
    /**
     * 
     * @type {string}
     * @memberof TariffGroupAttribute
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof TariffGroupAttribute
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof TariffGroupAttribute
     */
    'deletedAt': string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const TariffGroupAttributeTypeEnum = {
    Language: 'language',
    PickupZone: 'pickup_zone'
} as const;

export type TariffGroupAttributeTypeEnum = typeof TariffGroupAttributeTypeEnum[keyof typeof TariffGroupAttributeTypeEnum];


/**
 * 
 * @export
 * @interface TariffGroupPriceInfo
 */
export interface TariffGroupPriceInfo {
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof TariffGroupPriceInfo
     */
    'defaultPrice': CurrencyInfo;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof TariffGroupPriceInfo
     */
    'maxPrice': CurrencyInfo;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof TariffGroupPriceInfo
     */
    'minPrice': CurrencyInfo;
}
/**
 * 
 * @export
 * @interface TariffQuantity
 */
export interface TariffQuantity {
    /**
     * 
     * @type {string}
     * @memberof TariffQuantity
     */
    'tariffId': string;
    /**
     * 
     * @type {OccupationInfo}
     * @memberof TariffQuantity
     */
    'occupation': OccupationInfo;
}
/**
 * 
 * @export
 * @interface TariffScheduleUnitPrice
 */
export interface TariffScheduleUnitPrice {
    /**
     * 
     * @type {string}
     * @memberof TariffScheduleUnitPrice
     */
    'time': string | null;
    /**
     * 
     * @type {Array<TariffUnitPrice>}
     * @memberof TariffScheduleUnitPrice
     */
    'tariffs': Array<TariffUnitPrice>;
    /**
     * The charge summary for the tariff unit price. Will only be present if the tariff unit price is for a reschedule.
     * @type {RescheduleChargeSummary}
     * @memberof TariffScheduleUnitPrice
     */
    'chargeSummary'?: RescheduleChargeSummary;
}
/**
 * 
 * @export
 * @interface TariffType
 */
export interface TariffType {
    /**
     * 
     * @type {string}
     * @memberof TariffType
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TariffType
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface TariffTypeVerification
 */
export interface TariffTypeVerification {
    /**
     * 
     * @type {string}
     * @memberof TariffTypeVerification
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TariffTypeVerification
     */
    'tariffTypeId': string;
    /**
     * 
     * @type {string}
     * @memberof TariffTypeVerification
     */
    'tariffVerificationId': string;
    /**
     * 
     * @type {TariffVerification}
     * @memberof TariffTypeVerification
     */
    'tariffVerification': TariffVerification;
    /**
     * 
     * @type {string}
     * @memberof TariffTypeVerification
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof TariffTypeVerification
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface TariffUnitPrice
 */
export interface TariffUnitPrice {
    /**
     * 
     * @type {string}
     * @memberof TariffUnitPrice
     */
    'tariffId': string;
    /**
     * 
     * @type {number}
     * @memberof TariffUnitPrice
     */
    'priceCents': number;
    /**
     * 
     * @type {CurrencyInfo}
     * @memberof TariffUnitPrice
     */
    'priceCurrencyInfo': CurrencyInfo | null;
    /**
     * Inputs required for final RM price on this tariff. Empty means the price is correct without an extended GET. Contains tariff_quantity when quantity-based RM applies. 
     * @type {Array<PricingInputType>}
     * @memberof TariffUnitPrice
     */
    'requiredPricingInputs': Array<PricingInputType>;
}
/**
 * 
 * @export
 * @interface TariffVerification
 */
export interface TariffVerification {
    /**
     * 
     * @type {string}
     * @memberof TariffVerification
     */
    'name': string;
    /**
     * 
     * @type {TariffVerificationTypeEnum}
     * @memberof TariffVerification
     */
    'type': TariffVerificationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof TariffVerification
     */
    'inputLabel': string | null;
    /**
     * 
     * @type {string}
     * @memberof TariffVerification
     */
    'helperText': string | null;
    /**
     * 
     * @type {TariffVerificationValidationTypeEnum}
     * @memberof TariffVerification
     */
    'validationType': TariffVerificationValidationTypeEnum;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const TariffVerificationTypeEnum = {
    Document: 'document',
    Date: 'date',
    BinCode: 'bin_code'
} as const;

export type TariffVerificationTypeEnum = typeof TariffVerificationTypeEnum[keyof typeof TariffVerificationTypeEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const TariffVerificationValidationTypeEnum = {
    Items: 'items',
    DateInterval: 'date_interval',
    PresentOnSite: 'present_on_site'
} as const;

export type TariffVerificationValidationTypeEnum = typeof TariffVerificationValidationTypeEnum[keyof typeof TariffVerificationValidationTypeEnum];


/**
 * 
 * @export
 * @interface Transaction
 */
export interface Transaction {
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'id': string;
    /**
     * 
     * @type {boolean}
     * @memberof Transaction
     */
    'succeeded': boolean;
    /**
     * 
     * @type {TransactionPaymentMethod}
     * @memberof Transaction
     */
    'paymentMethod': TransactionPaymentMethod;
    /**
     * Card brand (e.g. visa, mastercard). Null for non-card methods such as Pix.
     * @type {string}
     * @memberof Transaction
     */
    'brand': string | null;
    /**
     * Number of installments. 1 for methods that don\'t support installments (e.g. Pix, debit).
     * @type {number}
     * @memberof Transaction
     */
    'installments': number;
    /**
     * 
     * @type {boolean}
     * @memberof Transaction
     */
    'pending': boolean;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'paymentUrl': string | null;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'expiresAt': string | null;
    /**
     * 
     * @type {TransactionPix}
     * @memberof Transaction
     */
    'pix': TransactionPix | null;
    /**
     * External authentication challenge data returned when the transaction is pending cardholder verification (3DS). Null when no challenge is required.
     * @type {PaymentMethodExternalAuthentication}
     * @memberof Transaction
     */
    'externalAuthentication': PaymentMethodExternalAuthentication | null;
}
/**
 * 
 * @export
 * @interface TransactionPaymentMethod
 */
export interface TransactionPaymentMethod {
    /**
     * 
     * @type {string}
     * @memberof TransactionPaymentMethod
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface TransactionPix
 */
export interface TransactionPix {
    /**
     * 
     * @type {string}
     * @memberof TransactionPix
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof TransactionPix
     */
    'qrCode': string;
    /**
     * 
     * @type {TransactionReceiverInfo}
     * @memberof TransactionPix
     */
    'receiverInfo': TransactionReceiverInfo;
}
/**
 * 
 * @export
 * @interface TransactionReceiverInfo
 */
export interface TransactionReceiverInfo {
    /**
     * 
     * @type {string}
     * @memberof TransactionReceiverInfo
     */
    'financialInstitution': string;
    /**
     * 
     * @type {string}
     * @memberof TransactionReceiverInfo
     */
    'companyName': string;
    /**
     * 
     * @type {string}
     * @memberof TransactionReceiverInfo
     */
    'cnpj': string;
}
/**
 * 
 * @export
 * @interface TransactionRequest
 */
export interface TransactionRequest {
    /**
     * 
     * @type {string}
     * @memberof TransactionRequest
     */
    'paymentMethodId': string;
    /**
     * 
     * @type {string}
     * @memberof TransactionRequest
     */
    'returnUrl'?: string;
    /**
     * 
     * @type {PaymentCardParams}
     * @memberof TransactionRequest
     */
    'paymentCard'?: PaymentCardParams;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof TransactionRequest
     */
    'externalAuthentication'?: { [key: string]: any; };
    /**
     * 
     * @type {DeviceInfoParams}
     * @memberof TransactionRequest
     */
    'deviceInfo': DeviceInfoParams;
    /**
     * 
     * @type {string}
     * @memberof TransactionRequest
     */
    'sessionId'?: string | null;
}
/**
 * 
 * @export
 * @interface UpsellOffer
 */
export interface UpsellOffer {
    /**
     * Identifier of the upsell offer that produced this suggestion.
     * @type {string}
     * @memberof UpsellOffer
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UpsellOffer
     */
    'productId': string;
    /**
     * 
     * @type {Product}
     * @memberof UpsellOffer
     */
    'product': Product;
    /**
     * 
     * @type {number}
     * @memberof UpsellOffer
     */
    'priority': number;
    /**
     * 
     * @type {TariffGroupPriceInfo}
     * @memberof UpsellOffer
     */
    'priceInfo': TariffGroupPriceInfo;
}
/**
 * 
 * @export
 * @interface UserRequest
 */
export interface UserRequest {
    /**
     * 
     * @type {string}
     * @memberof UserRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UserRequest
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof UserRequest
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof UserRequest
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof UserRequest
     */
    'corporateName': string | null;
    /**
     * 
     * @type {string}
     * @memberof UserRequest
     */
    'countryCode': string | null;
    /**
     * 
     * @type {string}
     * @memberof UserRequest
     */
    'identityType': string;
    /**
     * 
     * @type {string}
     * @memberof UserRequest
     */
    'identity': string;
    /**
     * 
     * @type {string}
     * @memberof UserRequest
     */
    'birthdate': string | null;
    /**
     * 
     * @type {Address}
     * @memberof UserRequest
     */
    'address'?: Address | null;
}
/**
 * 
 * @export
 * @interface UtmParams
 */
export interface UtmParams {
    /**
     * 
     * @type {string}
     * @memberof UtmParams
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof UtmParams
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface ValidatePasswordRecoveryCodeRequest
 */
export interface ValidatePasswordRecoveryCodeRequest {
    /**
     * 
     * @type {string}
     * @memberof ValidatePasswordRecoveryCodeRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ValidatePasswordRecoveryCodeRequest
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface VerifyPhoneRequest
 */
export interface VerifyPhoneRequest {
    /**
     * 
     * @type {string}
     * @memberof VerifyPhoneRequest
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface Voucher
 */
export interface Voucher {
    /**
     * 
     * @type {string}
     * @memberof Voucher
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Voucher
     */
    'saleItemId': string;
    /**
     * 
     * @type {string}
     * @memberof Voucher
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof Voucher
     */
    'secret': string;
    /**
     * 
     * @type {string}
     * @memberof Voucher
     */
    'productName': string;
    /**
     * 
     * @type {number}
     * @memberof Voucher
     */
    'quantity': number;
    /**
     * 
     * @type {string}
     * @memberof Voucher
     */
    'consumedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof Voucher
     */
    'exceptionallyConsumedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof Voucher
     */
    'expiresAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof Voucher
     */
    'revokedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof Voucher
     */
    'scheduleDate': string | null;
    /**
     * 
     * @type {number}
     * @memberof Voucher
     */
    'scheduleTimeMinutes': number | null;
    /**
     * 
     * @type {Array<VoucherTariff>}
     * @memberof Voucher
     */
    'tariffs': Array<VoucherTariff>;
    /**
     * 
     * @type {Array<SaleResource>}
     * @memberof Voucher
     */
    'resources': Array<SaleResource>;
    /**
     * 
     * @type {Array<SaleAdditional>}
     * @memberof Voucher
     */
    'additionals': Array<SaleAdditional>;
    /**
     * 
     * @type {VoucherStatus}
     * @memberof Voucher
     */
    'status': VoucherStatus;
    /**
     * 
     * @type {string}
     * @memberof Voucher
     */
    'reservationId': string | null;
}


/**
 * 
 * @export
 * @interface VoucherQrCode
 */
export interface VoucherQrCode {
    /**
     * 
     * @type {string}
     * @memberof VoucherQrCode
     */
    'qrCode': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const VoucherStatus = {
    Confirmed: 'confirmed',
    Pending: 'pending'
} as const;

export type VoucherStatus = typeof VoucherStatus[keyof typeof VoucherStatus];


/**
 * 
 * @export
 * @interface VoucherTariff
 */
export interface VoucherTariff {
    /**
     * 
     * @type {string}
     * @memberof VoucherTariff
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof VoucherTariff
     */
    'quantity': number;
}

/**
 * AppsApi - axios parameter creator
 * @export
 */
export const AppsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppInfo: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/apps/own/info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AppsApi - functional programming interface
 * @export
 */
export const AppsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AppsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppInfo(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppInfo(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppsApi.getAppInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AppsApi - factory interface
 * @export
 */
export const AppsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AppsApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppInfo(options?: RawAxiosRequestConfig): AxiosPromise<AppInfo> {
            return localVarFp.getAppInfo(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AppsApi - object-oriented interface
 * @export
 * @class AppsApi
 * @extends {BaseAPI}
 */
export class AppsApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppsApi
     */
    public getAppInfo(options?: RawAxiosRequestConfig) {
        return AppsApiFp(this.configuration).getAppInfo(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BuyersApi - axios parameter creator
 * @export
 */
export const BuyersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {LoginRequest} loginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buyerLogin: async (loginRequest: LoginRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginRequest' is not null or undefined
            assertParamExists('buyerLogin', 'loginRequest', loginRequest)
            const localVarPath = `/buyers/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SignupRequest} signupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buyerSignup: async (signupRequest: SignupRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'signupRequest' is not null or undefined
            assertParamExists('buyerSignup', 'signupRequest', signupRequest)
            const localVarPath = `/buyers/signup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(signupRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkEmail: async (email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('checkEmail', 'email', email)
            const localVarPath = `/buyers/checkEmail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ConfirmBuyerEmailChangeRequest} confirmBuyerEmailChangeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmBuyerEmailChange: async (confirmBuyerEmailChangeRequest: ConfirmBuyerEmailChangeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'confirmBuyerEmailChangeRequest' is not null or undefined
            assertParamExists('confirmBuyerEmailChange', 'confirmBuyerEmailChangeRequest', confirmBuyerEmailChangeRequest)
            const localVarPath = `/buyers/me/confirmEmailChange`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(confirmBuyerEmailChangeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declineBuyerEmailChange: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/buyers/me/declineEmailChange`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwnBuyer: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/buyers/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrivacyPolicy: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/buyers/privacyPolicy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTermsOfUse: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/buyers/termsOfUse`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RecoverPasswordRequest} recoverPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recoverPassword: async (recoverPasswordRequest: RecoverPasswordRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recoverPasswordRequest' is not null or undefined
            assertParamExists('recoverPassword', 'recoverPasswordRequest', recoverPasswordRequest)
            const localVarPath = `/buyers/recoverPassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(recoverPasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPhoneVerification: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/buyers/me/phoneVerification/request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ResetPasswordRequest} resetPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword: async (resetPasswordRequest: ResetPasswordRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resetPasswordRequest' is not null or undefined
            assertParamExists('resetPassword', 'resetPasswordRequest', resetPasswordRequest)
            const localVarPath = `/buyers/resetPassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetPasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SendOtpRequest} sendOtpRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendOtp: async (sendOtpRequest: SendOtpRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendOtpRequest' is not null or undefined
            assertParamExists('sendOtp', 'sendOtpRequest', sendOtpRequest)
            const localVarPath = `/buyers/otp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendOtpRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UserRequest} userRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOwnBuyer: async (userRequest: UserRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userRequest' is not null or undefined
            assertParamExists('updateOwnBuyer', 'userRequest', userRequest)
            const localVarPath = `/buyers/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ValidatePasswordRecoveryCodeRequest} validatePasswordRecoveryCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validatePasswordRecoveryCode: async (validatePasswordRecoveryCodeRequest: ValidatePasswordRecoveryCodeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'validatePasswordRecoveryCodeRequest' is not null or undefined
            assertParamExists('validatePasswordRecoveryCode', 'validatePasswordRecoveryCodeRequest', validatePasswordRecoveryCodeRequest)
            const localVarPath = `/buyers/validateCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(validatePasswordRecoveryCodeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {VerifyPhoneRequest} verifyPhoneRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyPhone: async (verifyPhoneRequest: VerifyPhoneRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verifyPhoneRequest' is not null or undefined
            assertParamExists('verifyPhone', 'verifyPhoneRequest', verifyPhoneRequest)
            const localVarPath = `/buyers/me/phoneVerification/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyPhoneRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BuyersApi - functional programming interface
 * @export
 */
export const BuyersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BuyersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {LoginRequest} loginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async buyerLogin(loginRequest: LoginRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Buyer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.buyerLogin(loginRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuyersApi.buyerLogin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SignupRequest} signupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async buyerSignup(signupRequest: SignupRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Buyer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.buyerSignup(signupRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuyersApi.buyerSignup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkEmail(email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailAvailability>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkEmail(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuyersApi.checkEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ConfirmBuyerEmailChangeRequest} confirmBuyerEmailChangeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmBuyerEmailChange(confirmBuyerEmailChangeRequest: ConfirmBuyerEmailChangeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Buyer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmBuyerEmailChange(confirmBuyerEmailChangeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuyersApi.confirmBuyerEmailChange']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async declineBuyerEmailChange(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.declineBuyerEmailChange(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuyersApi.declineBuyerEmailChange']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOwnBuyer(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Buyer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOwnBuyer(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuyersApi.getOwnBuyer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrivacyPolicy(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgreementDocument>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrivacyPolicy(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuyersApi.getPrivacyPolicy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTermsOfUse(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgreementDocument>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTermsOfUse(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuyersApi.getTermsOfUse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RecoverPasswordRequest} recoverPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recoverPassword(recoverPasswordRequest: RecoverPasswordRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Buyer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recoverPassword(recoverPasswordRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuyersApi.recoverPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestPhoneVerification(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestPhoneVerification(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuyersApi.requestPhoneVerification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ResetPasswordRequest} resetPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetPassword(resetPasswordRequest: ResetPasswordRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetPassword(resetPasswordRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuyersApi.resetPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SendOtpRequest} sendOtpRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendOtp(sendOtpRequest: SendOtpRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendOtp(sendOtpRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuyersApi.sendOtp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UserRequest} userRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOwnBuyer(userRequest: UserRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Buyer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOwnBuyer(userRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuyersApi.updateOwnBuyer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ValidatePasswordRecoveryCodeRequest} validatePasswordRecoveryCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validatePasswordRecoveryCode(validatePasswordRecoveryCodeRequest: ValidatePasswordRecoveryCodeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validatePasswordRecoveryCode(validatePasswordRecoveryCodeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuyersApi.validatePasswordRecoveryCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {VerifyPhoneRequest} verifyPhoneRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyPhone(verifyPhoneRequest: VerifyPhoneRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyPhone(verifyPhoneRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuyersApi.verifyPhone']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BuyersApi - factory interface
 * @export
 */
export const BuyersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BuyersApiFp(configuration)
    return {
        /**
         * 
         * @param {LoginRequest} loginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buyerLogin(loginRequest: LoginRequest, options?: RawAxiosRequestConfig): AxiosPromise<Buyer> {
            return localVarFp.buyerLogin(loginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SignupRequest} signupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buyerSignup(signupRequest: SignupRequest, options?: RawAxiosRequestConfig): AxiosPromise<Buyer> {
            return localVarFp.buyerSignup(signupRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkEmail(email: string, options?: RawAxiosRequestConfig): AxiosPromise<EmailAvailability> {
            return localVarFp.checkEmail(email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ConfirmBuyerEmailChangeRequest} confirmBuyerEmailChangeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmBuyerEmailChange(confirmBuyerEmailChangeRequest: ConfirmBuyerEmailChangeRequest, options?: RawAxiosRequestConfig): AxiosPromise<Buyer> {
            return localVarFp.confirmBuyerEmailChange(confirmBuyerEmailChangeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declineBuyerEmailChange(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.declineBuyerEmailChange(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwnBuyer(options?: RawAxiosRequestConfig): AxiosPromise<Buyer> {
            return localVarFp.getOwnBuyer(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrivacyPolicy(options?: RawAxiosRequestConfig): AxiosPromise<AgreementDocument> {
            return localVarFp.getPrivacyPolicy(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTermsOfUse(options?: RawAxiosRequestConfig): AxiosPromise<AgreementDocument> {
            return localVarFp.getTermsOfUse(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RecoverPasswordRequest} recoverPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recoverPassword(recoverPasswordRequest: RecoverPasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<Buyer> {
            return localVarFp.recoverPassword(recoverPasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPhoneVerification(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.requestPhoneVerification(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ResetPasswordRequest} resetPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(resetPasswordRequest: ResetPasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.resetPassword(resetPasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SendOtpRequest} sendOtpRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendOtp(sendOtpRequest: SendOtpRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendOtp(sendOtpRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserRequest} userRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOwnBuyer(userRequest: UserRequest, options?: RawAxiosRequestConfig): AxiosPromise<Buyer> {
            return localVarFp.updateOwnBuyer(userRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ValidatePasswordRecoveryCodeRequest} validatePasswordRecoveryCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validatePasswordRecoveryCode(validatePasswordRecoveryCodeRequest: ValidatePasswordRecoveryCodeRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.validatePasswordRecoveryCode(validatePasswordRecoveryCodeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VerifyPhoneRequest} verifyPhoneRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyPhone(verifyPhoneRequest: VerifyPhoneRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.verifyPhone(verifyPhoneRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BuyersApi - object-oriented interface
 * @export
 * @class BuyersApi
 * @extends {BaseAPI}
 */
export class BuyersApi extends BaseAPI {
    /**
     * 
     * @param {LoginRequest} loginRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyersApi
     */
    public buyerLogin(loginRequest: LoginRequest, options?: RawAxiosRequestConfig) {
        return BuyersApiFp(this.configuration).buyerLogin(loginRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SignupRequest} signupRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyersApi
     */
    public buyerSignup(signupRequest: SignupRequest, options?: RawAxiosRequestConfig) {
        return BuyersApiFp(this.configuration).buyerSignup(signupRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyersApi
     */
    public checkEmail(email: string, options?: RawAxiosRequestConfig) {
        return BuyersApiFp(this.configuration).checkEmail(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ConfirmBuyerEmailChangeRequest} confirmBuyerEmailChangeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyersApi
     */
    public confirmBuyerEmailChange(confirmBuyerEmailChangeRequest: ConfirmBuyerEmailChangeRequest, options?: RawAxiosRequestConfig) {
        return BuyersApiFp(this.configuration).confirmBuyerEmailChange(confirmBuyerEmailChangeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyersApi
     */
    public declineBuyerEmailChange(options?: RawAxiosRequestConfig) {
        return BuyersApiFp(this.configuration).declineBuyerEmailChange(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyersApi
     */
    public getOwnBuyer(options?: RawAxiosRequestConfig) {
        return BuyersApiFp(this.configuration).getOwnBuyer(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyersApi
     */
    public getPrivacyPolicy(options?: RawAxiosRequestConfig) {
        return BuyersApiFp(this.configuration).getPrivacyPolicy(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyersApi
     */
    public getTermsOfUse(options?: RawAxiosRequestConfig) {
        return BuyersApiFp(this.configuration).getTermsOfUse(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RecoverPasswordRequest} recoverPasswordRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyersApi
     */
    public recoverPassword(recoverPasswordRequest: RecoverPasswordRequest, options?: RawAxiosRequestConfig) {
        return BuyersApiFp(this.configuration).recoverPassword(recoverPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyersApi
     */
    public requestPhoneVerification(options?: RawAxiosRequestConfig) {
        return BuyersApiFp(this.configuration).requestPhoneVerification(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ResetPasswordRequest} resetPasswordRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyersApi
     */
    public resetPassword(resetPasswordRequest: ResetPasswordRequest, options?: RawAxiosRequestConfig) {
        return BuyersApiFp(this.configuration).resetPassword(resetPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SendOtpRequest} sendOtpRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyersApi
     */
    public sendOtp(sendOtpRequest: SendOtpRequest, options?: RawAxiosRequestConfig) {
        return BuyersApiFp(this.configuration).sendOtp(sendOtpRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserRequest} userRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyersApi
     */
    public updateOwnBuyer(userRequest: UserRequest, options?: RawAxiosRequestConfig) {
        return BuyersApiFp(this.configuration).updateOwnBuyer(userRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ValidatePasswordRecoveryCodeRequest} validatePasswordRecoveryCodeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyersApi
     */
    public validatePasswordRecoveryCode(validatePasswordRecoveryCodeRequest: ValidatePasswordRecoveryCodeRequest, options?: RawAxiosRequestConfig) {
        return BuyersApiFp(this.configuration).validatePasswordRecoveryCode(validatePasswordRecoveryCodeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VerifyPhoneRequest} verifyPhoneRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyersApi
     */
    public verifyPhone(verifyPhoneRequest: VerifyPhoneRequest, options?: RawAxiosRequestConfig) {
        return BuyersApiFp(this.configuration).verifyPhone(verifyPhoneRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CartItemsApi - axios parameter creator
 * @export
 */
export const CartItemsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add multiple items to the cart in a single request. Each entry may carry product package metadata and an upsell flag. Used by the upsell booking flow to add every selected suggestion at once. Uses the same per-item validations as the single add-item endpoint.
         * @param {string} cartId 
         * @param {AddCartItemsRequest} addCartItemsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCartItems: async (cartId: string, addCartItemsRequest: AddCartItemsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cartId' is not null or undefined
            assertParamExists('addCartItems', 'cartId', cartId)
            // verify required parameter 'addCartItemsRequest' is not null or undefined
            assertParamExists('addCartItems', 'addCartItemsRequest', addCartItemsRequest)
            const localVarPath = `/carts/{cartId}/items/batch`
                .replace(`{${"cartId"}}`, encodeURIComponent(String(cartId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addCartItemsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CartItemsApi - functional programming interface
 * @export
 */
export const CartItemsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CartItemsApiAxiosParamCreator(configuration)
    return {
        /**
         * Add multiple items to the cart in a single request. Each entry may carry product package metadata and an upsell flag. Used by the upsell booking flow to add every selected suggestion at once. Uses the same per-item validations as the single add-item endpoint.
         * @param {string} cartId 
         * @param {AddCartItemsRequest} addCartItemsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addCartItems(cartId: string, addCartItemsRequest: AddCartItemsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CartItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addCartItems(cartId, addCartItemsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CartItemsApi.addCartItems']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CartItemsApi - factory interface
 * @export
 */
export const CartItemsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CartItemsApiFp(configuration)
    return {
        /**
         * Add multiple items to the cart in a single request. Each entry may carry product package metadata and an upsell flag. Used by the upsell booking flow to add every selected suggestion at once. Uses the same per-item validations as the single add-item endpoint.
         * @param {string} cartId 
         * @param {AddCartItemsRequest} addCartItemsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCartItems(cartId: string, addCartItemsRequest: AddCartItemsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<CartItem>> {
            return localVarFp.addCartItems(cartId, addCartItemsRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CartItemsApi - object-oriented interface
 * @export
 * @class CartItemsApi
 * @extends {BaseAPI}
 */
export class CartItemsApi extends BaseAPI {
    /**
     * Add multiple items to the cart in a single request. Each entry may carry product package metadata and an upsell flag. Used by the upsell booking flow to add every selected suggestion at once. Uses the same per-item validations as the single add-item endpoint.
     * @param {string} cartId 
     * @param {AddCartItemsRequest} addCartItemsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartItemsApi
     */
    public addCartItems(cartId: string, addCartItemsRequest: AddCartItemsRequest, options?: RawAxiosRequestConfig) {
        return CartItemsApiFp(this.configuration).addCartItems(cartId, addCartItemsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CartsApi - axios parameter creator
 * @export
 */
export const CartsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} cartId 
         * @param {AddCartItemRequest} addCartItemRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCartItem: async (cartId: string, addCartItemRequest: AddCartItemRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cartId' is not null or undefined
            assertParamExists('addCartItem', 'cartId', cartId)
            // verify required parameter 'addCartItemRequest' is not null or undefined
            assertParamExists('addCartItem', 'addCartItemRequest', addCartItemRequest)
            const localVarPath = `/carts/{cartId}/items`
                .replace(`{${"cartId"}}`, encodeURIComponent(String(cartId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addCartItemRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} cartId 
         * @param {AddProductPackageToCartRequest} addProductPackageToCartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProductPackageToCart: async (cartId: string, addProductPackageToCartRequest: AddProductPackageToCartRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cartId' is not null or undefined
            assertParamExists('addProductPackageToCart', 'cartId', cartId)
            // verify required parameter 'addProductPackageToCartRequest' is not null or undefined
            assertParamExists('addProductPackageToCart', 'addProductPackageToCartRequest', addProductPackageToCartRequest)
            const localVarPath = `/carts/{cartId}/productPackages`
                .replace(`{${"cartId"}}`, encodeURIComponent(String(cartId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addProductPackageToCartRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} cartId 
         * @param {CheckoutCartRequest} checkoutCartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkoutCart: async (cartId: string, checkoutCartRequest: CheckoutCartRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cartId' is not null or undefined
            assertParamExists('checkoutCart', 'cartId', cartId)
            // verify required parameter 'checkoutCartRequest' is not null or undefined
            assertParamExists('checkoutCart', 'checkoutCartRequest', checkoutCartRequest)
            const localVarPath = `/carts/{cartId}/checkout`
                .replace(`{${"cartId"}}`, encodeURIComponent(String(cartId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkoutCartRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new cart replicating the items, tariffs and quantities of an existing order. Used when an order can no longer be paid (for example, an expired Pix charge) and the buyer needs to retry the purchase without rebuilding the cart manually.
         * @summary Rebuilds a cart from an existing order
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        convertOrderToCart: async (orderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('convertOrderToCart', 'orderId', orderId)
            const localVarPath = `/orders/{orderId}/convertToCart`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateCartRequest} createCartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCart: async (createCartRequest: CreateCartRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCartRequest' is not null or undefined
            assertParamExists('createCart', 'createCartRequest', createCartRequest)
            const localVarPath = `/carts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCartRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} cartId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCart: async (cartId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cartId' is not null or undefined
            assertParamExists('getCart', 'cartId', cartId)
            const localVarPath = `/carts/{cartId}`
                .replace(`{${"cartId"}}`, encodeURIComponent(String(cartId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} cartId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCartCoupon: async (cartId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cartId' is not null or undefined
            assertParamExists('removeCartCoupon', 'cartId', cartId)
            const localVarPath = `/carts/{cartId}/coupon`
                .replace(`{${"cartId"}}`, encodeURIComponent(String(cartId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} cartId 
         * @param {string} cartItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCartItem: async (cartId: string, cartItemId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cartId' is not null or undefined
            assertParamExists('removeCartItem', 'cartId', cartId)
            // verify required parameter 'cartItemId' is not null or undefined
            assertParamExists('removeCartItem', 'cartItemId', cartItemId)
            const localVarPath = `/carts/{cartId}/items/{cartItemId}`
                .replace(`{${"cartId"}}`, encodeURIComponent(String(cartId)))
                .replace(`{${"cartItemId"}}`, encodeURIComponent(String(cartItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} cartId 
         * @param {string} productPackageUnitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeProductPackageFromCart: async (cartId: string, productPackageUnitId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cartId' is not null or undefined
            assertParamExists('removeProductPackageFromCart', 'cartId', cartId)
            // verify required parameter 'productPackageUnitId' is not null or undefined
            assertParamExists('removeProductPackageFromCart', 'productPackageUnitId', productPackageUnitId)
            const localVarPath = `/carts/{cartId}/productPackages/{productPackageUnitId}`
                .replace(`{${"cartId"}}`, encodeURIComponent(String(cartId)))
                .replace(`{${"productPackageUnitId"}}`, encodeURIComponent(String(productPackageUnitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} cartId 
         * @param {SetCartAffiliationRequest} setCartAffiliationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCartAffiliation: async (cartId: string, setCartAffiliationRequest: SetCartAffiliationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cartId' is not null or undefined
            assertParamExists('setCartAffiliation', 'cartId', cartId)
            // verify required parameter 'setCartAffiliationRequest' is not null or undefined
            assertParamExists('setCartAffiliation', 'setCartAffiliationRequest', setCartAffiliationRequest)
            const localVarPath = `/carts/{cartId}/affiliation`
                .replace(`{${"cartId"}}`, encodeURIComponent(String(cartId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setCartAffiliationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} cartId 
         * @param {SetCartCouponRequest} setCartCouponRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCartCoupon: async (cartId: string, setCartCouponRequest: SetCartCouponRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cartId' is not null or undefined
            assertParamExists('setCartCoupon', 'cartId', cartId)
            // verify required parameter 'setCartCouponRequest' is not null or undefined
            assertParamExists('setCartCoupon', 'setCartCouponRequest', setCartCouponRequest)
            const localVarPath = `/carts/{cartId}/coupon`
                .replace(`{${"cartId"}}`, encodeURIComponent(String(cartId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setCartCouponRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} cartId 
         * @param {SetCartSaleOriginRequest} setCartSaleOriginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCartSaleOrigin: async (cartId: string, setCartSaleOriginRequest: SetCartSaleOriginRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cartId' is not null or undefined
            assertParamExists('setCartSaleOrigin', 'cartId', cartId)
            // verify required parameter 'setCartSaleOriginRequest' is not null or undefined
            assertParamExists('setCartSaleOrigin', 'setCartSaleOriginRequest', setCartSaleOriginRequest)
            const localVarPath = `/carts/{cartId}/origin`
                .replace(`{${"cartId"}}`, encodeURIComponent(String(cartId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setCartSaleOriginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CartsApi - functional programming interface
 * @export
 */
export const CartsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CartsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} cartId 
         * @param {AddCartItemRequest} addCartItemRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addCartItem(cartId: string, addCartItemRequest: AddCartItemRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CartItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addCartItem(cartId, addCartItemRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CartsApi.addCartItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} cartId 
         * @param {AddProductPackageToCartRequest} addProductPackageToCartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addProductPackageToCart(cartId: string, addProductPackageToCartRequest: AddProductPackageToCartRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CartItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addProductPackageToCart(cartId, addProductPackageToCartRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CartsApi.addProductPackageToCart']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} cartId 
         * @param {CheckoutCartRequest} checkoutCartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkoutCart(cartId: string, checkoutCartRequest: CheckoutCartRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Order>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkoutCart(cartId, checkoutCartRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CartsApi.checkoutCart']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a new cart replicating the items, tariffs and quantities of an existing order. Used when an order can no longer be paid (for example, an expired Pix charge) and the buyer needs to retry the purchase without rebuilding the cart manually.
         * @summary Rebuilds a cart from an existing order
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async convertOrderToCart(orderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Cart>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.convertOrderToCart(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CartsApi.convertOrderToCart']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateCartRequest} createCartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCart(createCartRequest: CreateCartRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Cart>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCart(createCartRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CartsApi.createCart']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} cartId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCart(cartId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Cart>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCart(cartId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CartsApi.getCart']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} cartId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeCartCoupon(cartId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Cart>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeCartCoupon(cartId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CartsApi.removeCartCoupon']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} cartId 
         * @param {string} cartItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeCartItem(cartId: string, cartItemId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeCartItem(cartId, cartItemId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CartsApi.removeCartItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} cartId 
         * @param {string} productPackageUnitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeProductPackageFromCart(cartId: string, productPackageUnitId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeProductPackageFromCart(cartId, productPackageUnitId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CartsApi.removeProductPackageFromCart']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} cartId 
         * @param {SetCartAffiliationRequest} setCartAffiliationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setCartAffiliation(cartId: string, setCartAffiliationRequest: SetCartAffiliationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Cart>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setCartAffiliation(cartId, setCartAffiliationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CartsApi.setCartAffiliation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} cartId 
         * @param {SetCartCouponRequest} setCartCouponRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setCartCoupon(cartId: string, setCartCouponRequest: SetCartCouponRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Cart>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setCartCoupon(cartId, setCartCouponRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CartsApi.setCartCoupon']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} cartId 
         * @param {SetCartSaleOriginRequest} setCartSaleOriginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setCartSaleOrigin(cartId: string, setCartSaleOriginRequest: SetCartSaleOriginRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Cart>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setCartSaleOrigin(cartId, setCartSaleOriginRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CartsApi.setCartSaleOrigin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CartsApi - factory interface
 * @export
 */
export const CartsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CartsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} cartId 
         * @param {AddCartItemRequest} addCartItemRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCartItem(cartId: string, addCartItemRequest: AddCartItemRequest, options?: RawAxiosRequestConfig): AxiosPromise<CartItem> {
            return localVarFp.addCartItem(cartId, addCartItemRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} cartId 
         * @param {AddProductPackageToCartRequest} addProductPackageToCartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProductPackageToCart(cartId: string, addProductPackageToCartRequest: AddProductPackageToCartRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<CartItem>> {
            return localVarFp.addProductPackageToCart(cartId, addProductPackageToCartRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} cartId 
         * @param {CheckoutCartRequest} checkoutCartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkoutCart(cartId: string, checkoutCartRequest: CheckoutCartRequest, options?: RawAxiosRequestConfig): AxiosPromise<Order> {
            return localVarFp.checkoutCart(cartId, checkoutCartRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new cart replicating the items, tariffs and quantities of an existing order. Used when an order can no longer be paid (for example, an expired Pix charge) and the buyer needs to retry the purchase without rebuilding the cart manually.
         * @summary Rebuilds a cart from an existing order
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        convertOrderToCart(orderId: string, options?: RawAxiosRequestConfig): AxiosPromise<Cart> {
            return localVarFp.convertOrderToCart(orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateCartRequest} createCartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCart(createCartRequest: CreateCartRequest, options?: RawAxiosRequestConfig): AxiosPromise<Cart> {
            return localVarFp.createCart(createCartRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} cartId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCart(cartId: string, options?: RawAxiosRequestConfig): AxiosPromise<Cart> {
            return localVarFp.getCart(cartId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} cartId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCartCoupon(cartId: string, options?: RawAxiosRequestConfig): AxiosPromise<Cart> {
            return localVarFp.removeCartCoupon(cartId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} cartId 
         * @param {string} cartItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCartItem(cartId: string, cartItemId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeCartItem(cartId, cartItemId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} cartId 
         * @param {string} productPackageUnitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeProductPackageFromCart(cartId: string, productPackageUnitId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeProductPackageFromCart(cartId, productPackageUnitId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} cartId 
         * @param {SetCartAffiliationRequest} setCartAffiliationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCartAffiliation(cartId: string, setCartAffiliationRequest: SetCartAffiliationRequest, options?: RawAxiosRequestConfig): AxiosPromise<Cart> {
            return localVarFp.setCartAffiliation(cartId, setCartAffiliationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} cartId 
         * @param {SetCartCouponRequest} setCartCouponRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCartCoupon(cartId: string, setCartCouponRequest: SetCartCouponRequest, options?: RawAxiosRequestConfig): AxiosPromise<Cart> {
            return localVarFp.setCartCoupon(cartId, setCartCouponRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} cartId 
         * @param {SetCartSaleOriginRequest} setCartSaleOriginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCartSaleOrigin(cartId: string, setCartSaleOriginRequest: SetCartSaleOriginRequest, options?: RawAxiosRequestConfig): AxiosPromise<Cart> {
            return localVarFp.setCartSaleOrigin(cartId, setCartSaleOriginRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CartsApi - object-oriented interface
 * @export
 * @class CartsApi
 * @extends {BaseAPI}
 */
export class CartsApi extends BaseAPI {
    /**
     * 
     * @param {string} cartId 
     * @param {AddCartItemRequest} addCartItemRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartsApi
     */
    public addCartItem(cartId: string, addCartItemRequest: AddCartItemRequest, options?: RawAxiosRequestConfig) {
        return CartsApiFp(this.configuration).addCartItem(cartId, addCartItemRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} cartId 
     * @param {AddProductPackageToCartRequest} addProductPackageToCartRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartsApi
     */
    public addProductPackageToCart(cartId: string, addProductPackageToCartRequest: AddProductPackageToCartRequest, options?: RawAxiosRequestConfig) {
        return CartsApiFp(this.configuration).addProductPackageToCart(cartId, addProductPackageToCartRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} cartId 
     * @param {CheckoutCartRequest} checkoutCartRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartsApi
     */
    public checkoutCart(cartId: string, checkoutCartRequest: CheckoutCartRequest, options?: RawAxiosRequestConfig) {
        return CartsApiFp(this.configuration).checkoutCart(cartId, checkoutCartRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new cart replicating the items, tariffs and quantities of an existing order. Used when an order can no longer be paid (for example, an expired Pix charge) and the buyer needs to retry the purchase without rebuilding the cart manually.
     * @summary Rebuilds a cart from an existing order
     * @param {string} orderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartsApi
     */
    public convertOrderToCart(orderId: string, options?: RawAxiosRequestConfig) {
        return CartsApiFp(this.configuration).convertOrderToCart(orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateCartRequest} createCartRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartsApi
     */
    public createCart(createCartRequest: CreateCartRequest, options?: RawAxiosRequestConfig) {
        return CartsApiFp(this.configuration).createCart(createCartRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} cartId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartsApi
     */
    public getCart(cartId: string, options?: RawAxiosRequestConfig) {
        return CartsApiFp(this.configuration).getCart(cartId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} cartId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartsApi
     */
    public removeCartCoupon(cartId: string, options?: RawAxiosRequestConfig) {
        return CartsApiFp(this.configuration).removeCartCoupon(cartId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} cartId 
     * @param {string} cartItemId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartsApi
     */
    public removeCartItem(cartId: string, cartItemId: string, options?: RawAxiosRequestConfig) {
        return CartsApiFp(this.configuration).removeCartItem(cartId, cartItemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} cartId 
     * @param {string} productPackageUnitId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartsApi
     */
    public removeProductPackageFromCart(cartId: string, productPackageUnitId: string, options?: RawAxiosRequestConfig) {
        return CartsApiFp(this.configuration).removeProductPackageFromCart(cartId, productPackageUnitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} cartId 
     * @param {SetCartAffiliationRequest} setCartAffiliationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartsApi
     */
    public setCartAffiliation(cartId: string, setCartAffiliationRequest: SetCartAffiliationRequest, options?: RawAxiosRequestConfig) {
        return CartsApiFp(this.configuration).setCartAffiliation(cartId, setCartAffiliationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} cartId 
     * @param {SetCartCouponRequest} setCartCouponRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartsApi
     */
    public setCartCoupon(cartId: string, setCartCouponRequest: SetCartCouponRequest, options?: RawAxiosRequestConfig) {
        return CartsApiFp(this.configuration).setCartCoupon(cartId, setCartCouponRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} cartId 
     * @param {SetCartSaleOriginRequest} setCartSaleOriginRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartsApi
     */
    public setCartSaleOrigin(cartId: string, setCartSaleOriginRequest: SetCartSaleOriginRequest, options?: RawAxiosRequestConfig) {
        return CartsApiFp(this.configuration).setCartSaleOrigin(cartId, setCartSaleOriginRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DirectLinksApi - axios parameter creator
 * @export
 */
export const DirectLinksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} directLinkCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirectLink: async (directLinkCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'directLinkCode' is not null or undefined
            assertParamExists('getDirectLink', 'directLinkCode', directLinkCode)
            const localVarPath = `/directLinks/{directLinkCode}`
                .replace(`{${"directLinkCode"}}`, encodeURIComponent(String(directLinkCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DirectLinksApi - functional programming interface
 * @export
 */
export const DirectLinksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DirectLinksApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} directLinkCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDirectLink(directLinkCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompleteDirectLink>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDirectLink(directLinkCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DirectLinksApi.getDirectLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DirectLinksApi - factory interface
 * @export
 */
export const DirectLinksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DirectLinksApiFp(configuration)
    return {
        /**
         * 
         * @param {string} directLinkCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirectLink(directLinkCode: string, options?: RawAxiosRequestConfig): AxiosPromise<CompleteDirectLink> {
            return localVarFp.getDirectLink(directLinkCode, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DirectLinksApi - object-oriented interface
 * @export
 * @class DirectLinksApi
 * @extends {BaseAPI}
 */
export class DirectLinksApi extends BaseAPI {
    /**
     * 
     * @param {string} directLinkCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectLinksApi
     */
    public getDirectLink(directLinkCode: string, options?: RawAxiosRequestConfig) {
        return DirectLinksApiFp(this.configuration).getDirectLink(directLinkCode, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FormInputsApi - axios parameter creator
 * @export
 */
export const FormInputsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} orderId 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderRequiredFormInputs: async (orderId: string, offset?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getOrderRequiredFormInputs', 'orderId', orderId)
            const localVarPath = `/orders/{orderId}/requiredFormInputs`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} saleId 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSaleRequiredFormInputs: async (saleId: string, offset?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'saleId' is not null or undefined
            assertParamExists('getSaleRequiredFormInputs', 'saleId', saleId)
            const localVarPath = `/sales/{saleId}/requiredFormInputs`
                .replace(`{${"saleId"}}`, encodeURIComponent(String(saleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orderId 
         * @param {SetRequiredFormInputsRequest} setRequiredFormInputsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setOrderRequiredFormInputs: async (orderId: string, setRequiredFormInputsRequest: SetRequiredFormInputsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('setOrderRequiredFormInputs', 'orderId', orderId)
            // verify required parameter 'setRequiredFormInputsRequest' is not null or undefined
            assertParamExists('setOrderRequiredFormInputs', 'setRequiredFormInputsRequest', setRequiredFormInputsRequest)
            const localVarPath = `/orders/{orderId}/requiredFormInputs`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setRequiredFormInputsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} saleId 
         * @param {SetRequiredFormInputsRequest} setRequiredFormInputsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setSaleRequiredFormInputs: async (saleId: string, setRequiredFormInputsRequest: SetRequiredFormInputsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'saleId' is not null or undefined
            assertParamExists('setSaleRequiredFormInputs', 'saleId', saleId)
            // verify required parameter 'setRequiredFormInputsRequest' is not null or undefined
            assertParamExists('setSaleRequiredFormInputs', 'setRequiredFormInputsRequest', setRequiredFormInputsRequest)
            const localVarPath = `/sales/{saleId}/requiredFormInputs`
                .replace(`{${"saleId"}}`, encodeURIComponent(String(saleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setRequiredFormInputsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FormInputsApi - functional programming interface
 * @export
 */
export const FormInputsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FormInputsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} orderId 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderRequiredFormInputs(orderId: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SaleFormInput>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderRequiredFormInputs(orderId, offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormInputsApi.getOrderRequiredFormInputs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} saleId 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSaleRequiredFormInputs(saleId: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SaleFormInput>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSaleRequiredFormInputs(saleId, offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormInputsApi.getSaleRequiredFormInputs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orderId 
         * @param {SetRequiredFormInputsRequest} setRequiredFormInputsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setOrderRequiredFormInputs(orderId: string, setRequiredFormInputsRequest: SetRequiredFormInputsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SaleFormInput>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setOrderRequiredFormInputs(orderId, setRequiredFormInputsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormInputsApi.setOrderRequiredFormInputs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} saleId 
         * @param {SetRequiredFormInputsRequest} setRequiredFormInputsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setSaleRequiredFormInputs(saleId: string, setRequiredFormInputsRequest: SetRequiredFormInputsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SaleFormInput>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setSaleRequiredFormInputs(saleId, setRequiredFormInputsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormInputsApi.setSaleRequiredFormInputs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FormInputsApi - factory interface
 * @export
 */
export const FormInputsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FormInputsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} orderId 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderRequiredFormInputs(orderId: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<SaleFormInput>> {
            return localVarFp.getOrderRequiredFormInputs(orderId, offset, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} saleId 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSaleRequiredFormInputs(saleId: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<SaleFormInput>> {
            return localVarFp.getSaleRequiredFormInputs(saleId, offset, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} orderId 
         * @param {SetRequiredFormInputsRequest} setRequiredFormInputsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setOrderRequiredFormInputs(orderId: string, setRequiredFormInputsRequest: SetRequiredFormInputsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<SaleFormInput>> {
            return localVarFp.setOrderRequiredFormInputs(orderId, setRequiredFormInputsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} saleId 
         * @param {SetRequiredFormInputsRequest} setRequiredFormInputsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setSaleRequiredFormInputs(saleId: string, setRequiredFormInputsRequest: SetRequiredFormInputsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<SaleFormInput>> {
            return localVarFp.setSaleRequiredFormInputs(saleId, setRequiredFormInputsRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FormInputsApi - object-oriented interface
 * @export
 * @class FormInputsApi
 * @extends {BaseAPI}
 */
export class FormInputsApi extends BaseAPI {
    /**
     * 
     * @param {string} orderId 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormInputsApi
     */
    public getOrderRequiredFormInputs(orderId: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return FormInputsApiFp(this.configuration).getOrderRequiredFormInputs(orderId, offset, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} saleId 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormInputsApi
     */
    public getSaleRequiredFormInputs(saleId: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return FormInputsApiFp(this.configuration).getSaleRequiredFormInputs(saleId, offset, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} orderId 
     * @param {SetRequiredFormInputsRequest} setRequiredFormInputsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormInputsApi
     */
    public setOrderRequiredFormInputs(orderId: string, setRequiredFormInputsRequest: SetRequiredFormInputsRequest, options?: RawAxiosRequestConfig) {
        return FormInputsApiFp(this.configuration).setOrderRequiredFormInputs(orderId, setRequiredFormInputsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} saleId 
     * @param {SetRequiredFormInputsRequest} setRequiredFormInputsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormInputsApi
     */
    public setSaleRequiredFormInputs(saleId: string, setRequiredFormInputsRequest: SetRequiredFormInputsRequest, options?: RawAxiosRequestConfig) {
        return FormInputsApiFp(this.configuration).setSaleRequiredFormInputs(saleId, setRequiredFormInputsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrdersApi - axios parameter creator
 * @export
 */
export const OrdersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrder: async (orderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getOrder', 'orderId', orderId)
            const localVarPath = `/orders/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {Array<OrderStatus>} [statuses] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrders: async (offset?: number, limit?: number, statuses?: Array<OrderStatus>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (statuses) {
                localVarQueryParameter['statuses'] = statuses.join(COLLECTION_FORMATS.csv);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrdersApi - functional programming interface
 * @export
 */
export const OrdersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrdersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrder(orderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Order>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrder(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.getOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {Array<OrderStatus>} [statuses] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrders(offset?: number, limit?: number, statuses?: Array<OrderStatus>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Order>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrders(offset, limit, statuses, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.getOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrdersApi - factory interface
 * @export
 */
export const OrdersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrdersApiFp(configuration)
    return {
        /**
         * 
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrder(orderId: string, options?: RawAxiosRequestConfig): AxiosPromise<Order> {
            return localVarFp.getOrder(orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {Array<OrderStatus>} [statuses] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrders(offset?: number, limit?: number, statuses?: Array<OrderStatus>, options?: RawAxiosRequestConfig): AxiosPromise<Array<Order>> {
            return localVarFp.getOrders(offset, limit, statuses, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrdersApi - object-oriented interface
 * @export
 * @class OrdersApi
 * @extends {BaseAPI}
 */
export class OrdersApi extends BaseAPI {
    /**
     * 
     * @param {string} orderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    public getOrder(orderId: string, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).getOrder(orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {Array<OrderStatus>} [statuses] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    public getOrders(offset?: number, limit?: number, statuses?: Array<OrderStatus>, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).getOrders(offset, limit, statuses, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PaymentMethodsApi - axios parameter creator
 * @export
 */
export const PaymentMethodsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} paymentMethodId 
         * @param {ExternalAuthenticationSetupParams} [externalAuthenticationSetupParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExternalAuthenticatePaymentMethod: async (paymentMethodId: string, externalAuthenticationSetupParams?: ExternalAuthenticationSetupParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentMethodId' is not null or undefined
            assertParamExists('getExternalAuthenticatePaymentMethod', 'paymentMethodId', paymentMethodId)
            const localVarPath = `/paymentMethods/{paymentMethodId}/externalAuthenticate`
                .replace(`{${"paymentMethodId"}}`, encodeURIComponent(String(paymentMethodId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(externalAuthenticationSetupParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaymentMethodsApi - functional programming interface
 * @export
 */
export const PaymentMethodsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PaymentMethodsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} paymentMethodId 
         * @param {ExternalAuthenticationSetupParams} [externalAuthenticationSetupParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExternalAuthenticatePaymentMethod(paymentMethodId: string, externalAuthenticationSetupParams?: ExternalAuthenticationSetupParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentMethodExternalAuthentication>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExternalAuthenticatePaymentMethod(paymentMethodId, externalAuthenticationSetupParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentMethodsApi.getExternalAuthenticatePaymentMethod']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PaymentMethodsApi - factory interface
 * @export
 */
export const PaymentMethodsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PaymentMethodsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} paymentMethodId 
         * @param {ExternalAuthenticationSetupParams} [externalAuthenticationSetupParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExternalAuthenticatePaymentMethod(paymentMethodId: string, externalAuthenticationSetupParams?: ExternalAuthenticationSetupParams, options?: RawAxiosRequestConfig): AxiosPromise<PaymentMethodExternalAuthentication> {
            return localVarFp.getExternalAuthenticatePaymentMethod(paymentMethodId, externalAuthenticationSetupParams, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PaymentMethodsApi - object-oriented interface
 * @export
 * @class PaymentMethodsApi
 * @extends {BaseAPI}
 */
export class PaymentMethodsApi extends BaseAPI {
    /**
     * 
     * @param {string} paymentMethodId 
     * @param {ExternalAuthenticationSetupParams} [externalAuthenticationSetupParams] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentMethodsApi
     */
    public getExternalAuthenticatePaymentMethod(paymentMethodId: string, externalAuthenticationSetupParams?: ExternalAuthenticationSetupParams, options?: RawAxiosRequestConfig) {
        return PaymentMethodsApiFp(this.configuration).getExternalAuthenticatePaymentMethod(paymentMethodId, externalAuthenticationSetupParams, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PaymentOptionsApi - axios parameter creator
 * @export
 */
export const PaymentOptionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} directLinkId 
         * @param {string} [sessionId] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirectLinkPaymentOptions: async (directLinkId: string, sessionId?: string, offset?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'directLinkId' is not null or undefined
            assertParamExists('getDirectLinkPaymentOptions', 'directLinkId', directLinkId)
            const localVarPath = `/directLinks/{directLinkId}/paymentOptions`
                .replace(`{${"directLinkId"}}`, encodeURIComponent(String(directLinkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sessionId !== undefined) {
                localVarQueryParameter['sessionId'] = sessionId;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orderId 
         * @param {string} [sessionId] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderPaymentOptions: async (orderId: string, sessionId?: string, offset?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getOrderPaymentOptions', 'orderId', orderId)
            const localVarPath = `/orders/{orderId}/paymentOptions`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sessionId !== undefined) {
                localVarQueryParameter['sessionId'] = sessionId;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} saleChangeId 
         * @param {string} [sessionId] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSaleChangePaymentOptions: async (saleChangeId: string, sessionId?: string, offset?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'saleChangeId' is not null or undefined
            assertParamExists('getSaleChangePaymentOptions', 'saleChangeId', saleChangeId)
            const localVarPath = `/saleChanges/{saleChangeId}/paymentOptions`
                .replace(`{${"saleChangeId"}}`, encodeURIComponent(String(saleChangeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sessionId !== undefined) {
                localVarQueryParameter['sessionId'] = sessionId;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} saleId 
         * @param {string} [sessionId] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalePaymentOptions: async (saleId: string, sessionId?: string, offset?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'saleId' is not null or undefined
            assertParamExists('getSalePaymentOptions', 'saleId', saleId)
            const localVarPath = `/sales/{saleId}/paymentOptions`
                .replace(`{${"saleId"}}`, encodeURIComponent(String(saleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sessionId !== undefined) {
                localVarQueryParameter['sessionId'] = sessionId;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaymentOptionsApi - functional programming interface
 * @export
 */
export const PaymentOptionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PaymentOptionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} directLinkId 
         * @param {string} [sessionId] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDirectLinkPaymentOptions(directLinkId: string, sessionId?: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PaymentOption>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDirectLinkPaymentOptions(directLinkId, sessionId, offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentOptionsApi.getDirectLinkPaymentOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orderId 
         * @param {string} [sessionId] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderPaymentOptions(orderId: string, sessionId?: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PaymentOption>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderPaymentOptions(orderId, sessionId, offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentOptionsApi.getOrderPaymentOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} saleChangeId 
         * @param {string} [sessionId] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSaleChangePaymentOptions(saleChangeId: string, sessionId?: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PaymentOption>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSaleChangePaymentOptions(saleChangeId, sessionId, offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentOptionsApi.getSaleChangePaymentOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} saleId 
         * @param {string} [sessionId] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSalePaymentOptions(saleId: string, sessionId?: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PaymentOption>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSalePaymentOptions(saleId, sessionId, offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentOptionsApi.getSalePaymentOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PaymentOptionsApi - factory interface
 * @export
 */
export const PaymentOptionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PaymentOptionsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} directLinkId 
         * @param {string} [sessionId] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirectLinkPaymentOptions(directLinkId: string, sessionId?: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<PaymentOption>> {
            return localVarFp.getDirectLinkPaymentOptions(directLinkId, sessionId, offset, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} orderId 
         * @param {string} [sessionId] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderPaymentOptions(orderId: string, sessionId?: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<PaymentOption>> {
            return localVarFp.getOrderPaymentOptions(orderId, sessionId, offset, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} saleChangeId 
         * @param {string} [sessionId] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSaleChangePaymentOptions(saleChangeId: string, sessionId?: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<PaymentOption>> {
            return localVarFp.getSaleChangePaymentOptions(saleChangeId, sessionId, offset, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} saleId 
         * @param {string} [sessionId] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalePaymentOptions(saleId: string, sessionId?: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<PaymentOption>> {
            return localVarFp.getSalePaymentOptions(saleId, sessionId, offset, limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PaymentOptionsApi - object-oriented interface
 * @export
 * @class PaymentOptionsApi
 * @extends {BaseAPI}
 */
export class PaymentOptionsApi extends BaseAPI {
    /**
     * 
     * @param {string} directLinkId 
     * @param {string} [sessionId] 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentOptionsApi
     */
    public getDirectLinkPaymentOptions(directLinkId: string, sessionId?: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return PaymentOptionsApiFp(this.configuration).getDirectLinkPaymentOptions(directLinkId, sessionId, offset, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} orderId 
     * @param {string} [sessionId] 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentOptionsApi
     */
    public getOrderPaymentOptions(orderId: string, sessionId?: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return PaymentOptionsApiFp(this.configuration).getOrderPaymentOptions(orderId, sessionId, offset, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} saleChangeId 
     * @param {string} [sessionId] 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentOptionsApi
     */
    public getSaleChangePaymentOptions(saleChangeId: string, sessionId?: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return PaymentOptionsApiFp(this.configuration).getSaleChangePaymentOptions(saleChangeId, sessionId, offset, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} saleId 
     * @param {string} [sessionId] 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentOptionsApi
     */
    public getSalePaymentOptions(saleId: string, sessionId?: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return PaymentOptionsApiFp(this.configuration).getSalePaymentOptions(saleId, sessionId, offset, limit, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductPackagesApi - axios parameter creator
 * @export
 */
export const ProductPackagesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} productPackageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductPackage: async (productPackageId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productPackageId' is not null or undefined
            assertParamExists('getProductPackage', 'productPackageId', productPackageId)
            const localVarPath = `/productPackages/{productPackageId}`
                .replace(`{${"productPackageId"}}`, encodeURIComponent(String(productPackageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productPackageId 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductPackageProducts: async (productPackageId: string, offset?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productPackageId' is not null or undefined
            assertParamExists('getProductPackageProducts', 'productPackageId', productPackageId)
            const localVarPath = `/productPackages/{productPackageId}/products`
                .replace(`{${"productPackageId"}}`, encodeURIComponent(String(productPackageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductPackagesApi - functional programming interface
 * @export
 */
export const ProductPackagesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductPackagesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} productPackageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductPackage(productPackageId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductPackage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductPackage(productPackageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductPackagesApi.getProductPackage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} productPackageId 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductPackageProducts(productPackageId: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductPackageProduct>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductPackageProducts(productPackageId, offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductPackagesApi.getProductPackageProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductPackagesApi - factory interface
 * @export
 */
export const ProductPackagesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductPackagesApiFp(configuration)
    return {
        /**
         * 
         * @param {string} productPackageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductPackage(productPackageId: string, options?: RawAxiosRequestConfig): AxiosPromise<ProductPackage> {
            return localVarFp.getProductPackage(productPackageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productPackageId 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductPackageProducts(productPackageId: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<ProductPackageProduct>> {
            return localVarFp.getProductPackageProducts(productPackageId, offset, limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductPackagesApi - object-oriented interface
 * @export
 * @class ProductPackagesApi
 * @extends {BaseAPI}
 */
export class ProductPackagesApi extends BaseAPI {
    /**
     * 
     * @param {string} productPackageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductPackagesApi
     */
    public getProductPackage(productPackageId: string, options?: RawAxiosRequestConfig) {
        return ProductPackagesApiFp(this.configuration).getProductPackage(productPackageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} productPackageId 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductPackagesApi
     */
    public getProductPackageProducts(productPackageId: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return ProductPackagesApiFp(this.configuration).getProductPackageProducts(productPackageId, offset, limit, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductsApi - axios parameter creator
 * @export
 */
export const ProductsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProduct: async (productId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getProduct', 'productId', productId)
            const localVarPath = `/products/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductAdditionals: async (productId: string, offset?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getProductAdditionals', 'productId', productId)
            const localVarPath = `/products/{productId}/additionals`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductDefaultTariffGroup: async (productId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getProductDefaultTariffGroup', 'productId', productId)
            const localVarPath = `/products/{productId}/defaultTariffGroup`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductImages: async (productId: string, offset?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getProductImages', 'productId', productId)
            const localVarPath = `/products/{productId}/images`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductItineraryMoments: async (productId: string, offset?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getProductItineraryMoments', 'productId', productId)
            const localVarPath = `/products/{productId}/itineraryMoments`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns product schedulings for the date window. When `pricingTariffSelections` is omitted, prices reflect baseline RM (no quantity-based discount). When present, each item must be exactly one colon separating tariff ID and non-negative integer quantity. Invalid selections may return 422 with codes `invalid_tariff_selection_format`, `unknown_tariff`, or `quantity_invalid`. 
         * @param {string} productId 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {Array<string>} [pricingTariffSelections] Optional CSV of atomic tariffId:quantity pairs (explode false). Omit for baseline pricing without quantity-based RM discount. Include all selectable tariff types; quantity may be 0. Each item must contain exactly one colon separating tariff ID (numeric string) and non-negative integer quantity. Invalid format may return 422 invalid_tariff_selection_format; unknown tariffId unknown_tariff; negative quantity quantity_invalid. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductSchedulings: async (productId: string, fromDate: string, toDate: string, offset?: number, limit?: number, pricingTariffSelections?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getProductSchedulings', 'productId', productId)
            // verify required parameter 'fromDate' is not null or undefined
            assertParamExists('getProductSchedulings', 'fromDate', fromDate)
            // verify required parameter 'toDate' is not null or undefined
            assertParamExists('getProductSchedulings', 'toDate', toDate)
            const localVarPath = `/products/{productId}/schedulings`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString().substring(0,10) :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString().substring(0,10) :
                    toDate;
            }

            if (pricingTariffSelections) {
                localVarQueryParameter['pricingTariffSelections'] = pricingTariffSelections.join(COLLECTION_FORMATS.csv);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProducts: async (offset?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductsApi - functional programming interface
 * @export
 */
export const ProductsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProduct(productId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Product>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProduct(productId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} productId 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductAdditionals(productId: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Additional>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductAdditionals(productId, offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getProductAdditionals']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductDefaultTariffGroup(productId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailedTariffGroup>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductDefaultTariffGroup(productId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getProductDefaultTariffGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} productId 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductImages(productId: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductImage>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductImages(productId, offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getProductImages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} productId 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductItineraryMoments(productId: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductItineraryMoment>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductItineraryMoments(productId, offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getProductItineraryMoments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns product schedulings for the date window. When `pricingTariffSelections` is omitted, prices reflect baseline RM (no quantity-based discount). When present, each item must be exactly one colon separating tariff ID and non-negative integer quantity. Invalid selections may return 422 with codes `invalid_tariff_selection_format`, `unknown_tariff`, or `quantity_invalid`. 
         * @param {string} productId 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {Array<string>} [pricingTariffSelections] Optional CSV of atomic tariffId:quantity pairs (explode false). Omit for baseline pricing without quantity-based RM discount. Include all selectable tariff types; quantity may be 0. Each item must contain exactly one colon separating tariff ID (numeric string) and non-negative integer quantity. Invalid format may return 422 invalid_tariff_selection_format; unknown tariffId unknown_tariff; negative quantity quantity_invalid. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductSchedulings(productId: string, fromDate: string, toDate: string, offset?: number, limit?: number, pricingTariffSelections?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Scheduling>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductSchedulings(productId, fromDate, toDate, offset, limit, pricingTariffSelections, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getProductSchedulings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProducts(offset?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Product>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProducts(offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductsApi - factory interface
 * @export
 */
export const ProductsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProduct(productId: string, options?: RawAxiosRequestConfig): AxiosPromise<Product> {
            return localVarFp.getProduct(productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductAdditionals(productId: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<Additional>> {
            return localVarFp.getProductAdditionals(productId, offset, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductDefaultTariffGroup(productId: string, options?: RawAxiosRequestConfig): AxiosPromise<DetailedTariffGroup> {
            return localVarFp.getProductDefaultTariffGroup(productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductImages(productId: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<ProductImage>> {
            return localVarFp.getProductImages(productId, offset, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductItineraryMoments(productId: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<ProductItineraryMoment>> {
            return localVarFp.getProductItineraryMoments(productId, offset, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns product schedulings for the date window. When `pricingTariffSelections` is omitted, prices reflect baseline RM (no quantity-based discount). When present, each item must be exactly one colon separating tariff ID and non-negative integer quantity. Invalid selections may return 422 with codes `invalid_tariff_selection_format`, `unknown_tariff`, or `quantity_invalid`. 
         * @param {string} productId 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {Array<string>} [pricingTariffSelections] Optional CSV of atomic tariffId:quantity pairs (explode false). Omit for baseline pricing without quantity-based RM discount. Include all selectable tariff types; quantity may be 0. Each item must contain exactly one colon separating tariff ID (numeric string) and non-negative integer quantity. Invalid format may return 422 invalid_tariff_selection_format; unknown tariffId unknown_tariff; negative quantity quantity_invalid. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductSchedulings(productId: string, fromDate: string, toDate: string, offset?: number, limit?: number, pricingTariffSelections?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<Array<Scheduling>> {
            return localVarFp.getProductSchedulings(productId, fromDate, toDate, offset, limit, pricingTariffSelections, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProducts(offset?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<Product>> {
            return localVarFp.getProducts(offset, limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductsApi - object-oriented interface
 * @export
 * @class ProductsApi
 * @extends {BaseAPI}
 */
export class ProductsApi extends BaseAPI {
    /**
     * 
     * @param {string} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getProduct(productId: string, options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).getProduct(productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} productId 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getProductAdditionals(productId: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).getProductAdditionals(productId, offset, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getProductDefaultTariffGroup(productId: string, options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).getProductDefaultTariffGroup(productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} productId 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getProductImages(productId: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).getProductImages(productId, offset, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} productId 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getProductItineraryMoments(productId: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).getProductItineraryMoments(productId, offset, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns product schedulings for the date window. When `pricingTariffSelections` is omitted, prices reflect baseline RM (no quantity-based discount). When present, each item must be exactly one colon separating tariff ID and non-negative integer quantity. Invalid selections may return 422 with codes `invalid_tariff_selection_format`, `unknown_tariff`, or `quantity_invalid`. 
     * @param {string} productId 
     * @param {string} fromDate 
     * @param {string} toDate 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {Array<string>} [pricingTariffSelections] Optional CSV of atomic tariffId:quantity pairs (explode false). Omit for baseline pricing without quantity-based RM discount. Include all selectable tariff types; quantity may be 0. Each item must contain exactly one colon separating tariff ID (numeric string) and non-negative integer quantity. Invalid format may return 422 invalid_tariff_selection_format; unknown tariffId unknown_tariff; negative quantity quantity_invalid. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getProductSchedulings(productId: string, fromDate: string, toDate: string, offset?: number, limit?: number, pricingTariffSelections?: Array<string>, options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).getProductSchedulings(productId, fromDate, toDate, offset, limit, pricingTariffSelections, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getProducts(offset?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).getProducts(offset, limit, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SaleChangesApi - axios parameter creator
 * @export
 */
export const SaleChangesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} saleChangeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSaleChange: async (saleChangeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'saleChangeId' is not null or undefined
            assertParamExists('cancelSaleChange', 'saleChangeId', saleChangeId)
            const localVarPath = `/saleChanges/{saleChangeId}`
                .replace(`{${"saleChangeId"}}`, encodeURIComponent(String(saleChangeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orderId 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {SaleChangeTypeEnum} [type] 
         * @param {SaleChangeStatusEnum} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderSaleChanges: async (orderId: string, offset?: number, limit?: number, type?: SaleChangeTypeEnum, status?: SaleChangeStatusEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getOrderSaleChanges', 'orderId', orderId)
            const localVarPath = `/orders/{orderId}/saleChanges`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} saleChangeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSaleChange: async (saleChangeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'saleChangeId' is not null or undefined
            assertParamExists('getSaleChange', 'saleChangeId', saleChangeId)
            const localVarPath = `/saleChanges/{saleChangeId}`
                .replace(`{${"saleChangeId"}}`, encodeURIComponent(String(saleChangeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} saleId 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {SaleChangeTypeEnum} [type] 
         * @param {SaleChangeStatusEnum} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSaleChanges: async (saleId: string, offset?: number, limit?: number, type?: SaleChangeTypeEnum, status?: SaleChangeStatusEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'saleId' is not null or undefined
            assertParamExists('getSaleChanges', 'saleId', saleId)
            const localVarPath = `/sales/{saleId}/changes`
                .replace(`{${"saleId"}}`, encodeURIComponent(String(saleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SaleChangesApi - functional programming interface
 * @export
 */
export const SaleChangesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SaleChangesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} saleChangeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelSaleChange(saleChangeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelSaleChange(saleChangeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SaleChangesApi.cancelSaleChange']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orderId 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {SaleChangeTypeEnum} [type] 
         * @param {SaleChangeStatusEnum} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderSaleChanges(orderId: string, offset?: number, limit?: number, type?: SaleChangeTypeEnum, status?: SaleChangeStatusEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SaleChange>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderSaleChanges(orderId, offset, limit, type, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SaleChangesApi.getOrderSaleChanges']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} saleChangeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSaleChange(saleChangeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SaleChange>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSaleChange(saleChangeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SaleChangesApi.getSaleChange']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} saleId 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {SaleChangeTypeEnum} [type] 
         * @param {SaleChangeStatusEnum} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSaleChanges(saleId: string, offset?: number, limit?: number, type?: SaleChangeTypeEnum, status?: SaleChangeStatusEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SaleChange>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSaleChanges(saleId, offset, limit, type, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SaleChangesApi.getSaleChanges']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SaleChangesApi - factory interface
 * @export
 */
export const SaleChangesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SaleChangesApiFp(configuration)
    return {
        /**
         * 
         * @param {string} saleChangeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSaleChange(saleChangeId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.cancelSaleChange(saleChangeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} orderId 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {SaleChangeTypeEnum} [type] 
         * @param {SaleChangeStatusEnum} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderSaleChanges(orderId: string, offset?: number, limit?: number, type?: SaleChangeTypeEnum, status?: SaleChangeStatusEnum, options?: RawAxiosRequestConfig): AxiosPromise<Array<SaleChange>> {
            return localVarFp.getOrderSaleChanges(orderId, offset, limit, type, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} saleChangeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSaleChange(saleChangeId: string, options?: RawAxiosRequestConfig): AxiosPromise<SaleChange> {
            return localVarFp.getSaleChange(saleChangeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} saleId 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {SaleChangeTypeEnum} [type] 
         * @param {SaleChangeStatusEnum} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSaleChanges(saleId: string, offset?: number, limit?: number, type?: SaleChangeTypeEnum, status?: SaleChangeStatusEnum, options?: RawAxiosRequestConfig): AxiosPromise<Array<SaleChange>> {
            return localVarFp.getSaleChanges(saleId, offset, limit, type, status, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SaleChangesApi - object-oriented interface
 * @export
 * @class SaleChangesApi
 * @extends {BaseAPI}
 */
export class SaleChangesApi extends BaseAPI {
    /**
     * 
     * @param {string} saleChangeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SaleChangesApi
     */
    public cancelSaleChange(saleChangeId: string, options?: RawAxiosRequestConfig) {
        return SaleChangesApiFp(this.configuration).cancelSaleChange(saleChangeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} orderId 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {SaleChangeTypeEnum} [type] 
     * @param {SaleChangeStatusEnum} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SaleChangesApi
     */
    public getOrderSaleChanges(orderId: string, offset?: number, limit?: number, type?: SaleChangeTypeEnum, status?: SaleChangeStatusEnum, options?: RawAxiosRequestConfig) {
        return SaleChangesApiFp(this.configuration).getOrderSaleChanges(orderId, offset, limit, type, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} saleChangeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SaleChangesApi
     */
    public getSaleChange(saleChangeId: string, options?: RawAxiosRequestConfig) {
        return SaleChangesApiFp(this.configuration).getSaleChange(saleChangeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} saleId 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {SaleChangeTypeEnum} [type] 
     * @param {SaleChangeStatusEnum} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SaleChangesApi
     */
    public getSaleChanges(saleId: string, offset?: number, limit?: number, type?: SaleChangeTypeEnum, status?: SaleChangeStatusEnum, options?: RawAxiosRequestConfig) {
        return SaleChangesApiFp(this.configuration).getSaleChanges(saleId, offset, limit, type, status, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SaleItemsApi - axios parameter creator
 * @export
 */
export const SaleItemsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} saleItemId 
         * @param {RescheduleSaleItemRequest} rescheduleSaleItemRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rescheduleSaleItem: async (saleItemId: string, rescheduleSaleItemRequest: RescheduleSaleItemRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'saleItemId' is not null or undefined
            assertParamExists('rescheduleSaleItem', 'saleItemId', saleItemId)
            // verify required parameter 'rescheduleSaleItemRequest' is not null or undefined
            assertParamExists('rescheduleSaleItem', 'rescheduleSaleItemRequest', rescheduleSaleItemRequest)
            const localVarPath = `/saleItems/{saleItemId}/reschedule`
                .replace(`{${"saleItemId"}}`, encodeURIComponent(String(saleItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rescheduleSaleItemRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SaleItemsApi - functional programming interface
 * @export
 */
export const SaleItemsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SaleItemsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} saleItemId 
         * @param {RescheduleSaleItemRequest} rescheduleSaleItemRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rescheduleSaleItem(saleItemId: string, rescheduleSaleItemRequest: RescheduleSaleItemRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailedSaleItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rescheduleSaleItem(saleItemId, rescheduleSaleItemRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SaleItemsApi.rescheduleSaleItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SaleItemsApi - factory interface
 * @export
 */
export const SaleItemsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SaleItemsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} saleItemId 
         * @param {RescheduleSaleItemRequest} rescheduleSaleItemRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rescheduleSaleItem(saleItemId: string, rescheduleSaleItemRequest: RescheduleSaleItemRequest, options?: RawAxiosRequestConfig): AxiosPromise<DetailedSaleItem> {
            return localVarFp.rescheduleSaleItem(saleItemId, rescheduleSaleItemRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SaleItemsApi - object-oriented interface
 * @export
 * @class SaleItemsApi
 * @extends {BaseAPI}
 */
export class SaleItemsApi extends BaseAPI {
    /**
     * 
     * @param {string} saleItemId 
     * @param {RescheduleSaleItemRequest} rescheduleSaleItemRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SaleItemsApi
     */
    public rescheduleSaleItem(saleItemId: string, rescheduleSaleItemRequest: RescheduleSaleItemRequest, options?: RawAxiosRequestConfig) {
        return SaleItemsApiFp(this.configuration).rescheduleSaleItem(saleItemId, rescheduleSaleItemRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SalesApi - axios parameter creator
 * @export
 */
export const SalesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} saleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSale: async (saleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'saleId' is not null or undefined
            assertParamExists('getSale', 'saleId', saleId)
            const localVarPath = `/sales/{saleId}`
                .replace(`{${"saleId"}}`, encodeURIComponent(String(saleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SalesApi - functional programming interface
 * @export
 */
export const SalesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SalesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} saleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSale(saleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Sale>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSale(saleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesApi.getSale']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SalesApi - factory interface
 * @export
 */
export const SalesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SalesApiFp(configuration)
    return {
        /**
         * 
         * @param {string} saleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSale(saleId: string, options?: RawAxiosRequestConfig): AxiosPromise<Sale> {
            return localVarFp.getSale(saleId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SalesApi - object-oriented interface
 * @export
 * @class SalesApi
 * @extends {BaseAPI}
 */
export class SalesApi extends BaseAPI {
    /**
     * 
     * @param {string} saleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesApi
     */
    public getSale(saleId: string, options?: RawAxiosRequestConfig) {
        return SalesApiFp(this.configuration).getSale(saleId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SchedulingsApi - axios parameter creator
 * @export
 */
export const SchedulingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} saleItemId 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableSaleItemSchedulings: async (saleItemId: string, offset?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'saleItemId' is not null or undefined
            assertParamExists('getAvailableSaleItemSchedulings', 'saleItemId', saleItemId)
            const localVarPath = `/saleItems/{saleItemId}/availableSchedulings`
                .replace(`{${"saleItemId"}}`, encodeURIComponent(String(saleItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SchedulingsApi - functional programming interface
 * @export
 */
export const SchedulingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SchedulingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} saleItemId 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableSaleItemSchedulings(saleItemId: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RescheduleScheduling>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableSaleItemSchedulings(saleItemId, offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulingsApi.getAvailableSaleItemSchedulings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SchedulingsApi - factory interface
 * @export
 */
export const SchedulingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SchedulingsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} saleItemId 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableSaleItemSchedulings(saleItemId: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<RescheduleScheduling>> {
            return localVarFp.getAvailableSaleItemSchedulings(saleItemId, offset, limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SchedulingsApi - object-oriented interface
 * @export
 * @class SchedulingsApi
 * @extends {BaseAPI}
 */
export class SchedulingsApi extends BaseAPI {
    /**
     * 
     * @param {string} saleItemId 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulingsApi
     */
    public getAvailableSaleItemSchedulings(saleItemId: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return SchedulingsApiFp(this.configuration).getAvailableSaleItemSchedulings(saleItemId, offset, limit, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SeatMapsApi - axios parameter creator
 * @export
 */
export const SeatMapsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns the seat map overview for a scheduling. When `pricingTariffSelections` is omitted, resource tariff prices reflect baseline RM. When present, use the same atomic tariffId:quantity pairs as `getProductSchedulings` so category tariff prices reflect quantity-based RM. Invalid selections may return 422 with codes `invalid_tariff_selection_format`, `unknown_tariff`, or `quantity_invalid`. 
         * @param {string} schedulingId 
         * @param {number} [scheduleTimeMinutes] 
         * @param {Array<string>} [pricingTariffSelections] Optional CSV of atomic tariffId:quantity pairs (explode false). Omit for baseline pricing without quantity-based RM discount. Include all selectable tariff types; quantity may be 0. Each item must contain exactly one colon separating tariff ID (numeric string) and non-negative integer quantity. Invalid format may return 422 invalid_tariff_selection_format; unknown tariffId unknown_tariff; negative quantity quantity_invalid. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchedulingSeatMapOverview: async (schedulingId: string, scheduleTimeMinutes?: number, pricingTariffSelections?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'schedulingId' is not null or undefined
            assertParamExists('getSchedulingSeatMapOverview', 'schedulingId', schedulingId)
            const localVarPath = `/schedulings/{schedulingId}/seatMapOverview`
                .replace(`{${"schedulingId"}}`, encodeURIComponent(String(schedulingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)

            if (scheduleTimeMinutes !== undefined) {
                localVarQueryParameter['scheduleTimeMinutes'] = scheduleTimeMinutes;
            }

            if (pricingTariffSelections) {
                localVarQueryParameter['pricingTariffSelections'] = pricingTariffSelections.join(COLLECTION_FORMATS.csv);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SeatMapsApi - functional programming interface
 * @export
 */
export const SeatMapsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SeatMapsApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns the seat map overview for a scheduling. When `pricingTariffSelections` is omitted, resource tariff prices reflect baseline RM. When present, use the same atomic tariffId:quantity pairs as `getProductSchedulings` so category tariff prices reflect quantity-based RM. Invalid selections may return 422 with codes `invalid_tariff_selection_format`, `unknown_tariff`, or `quantity_invalid`. 
         * @param {string} schedulingId 
         * @param {number} [scheduleTimeMinutes] 
         * @param {Array<string>} [pricingTariffSelections] Optional CSV of atomic tariffId:quantity pairs (explode false). Omit for baseline pricing without quantity-based RM discount. Include all selectable tariff types; quantity may be 0. Each item must contain exactly one colon separating tariff ID (numeric string) and non-negative integer quantity. Invalid format may return 422 invalid_tariff_selection_format; unknown tariffId unknown_tariff; negative quantity quantity_invalid. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSchedulingSeatMapOverview(schedulingId: string, scheduleTimeMinutes?: number, pricingTariffSelections?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SeatMapOverview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSchedulingSeatMapOverview(schedulingId, scheduleTimeMinutes, pricingTariffSelections, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SeatMapsApi.getSchedulingSeatMapOverview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SeatMapsApi - factory interface
 * @export
 */
export const SeatMapsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SeatMapsApiFp(configuration)
    return {
        /**
         * Returns the seat map overview for a scheduling. When `pricingTariffSelections` is omitted, resource tariff prices reflect baseline RM. When present, use the same atomic tariffId:quantity pairs as `getProductSchedulings` so category tariff prices reflect quantity-based RM. Invalid selections may return 422 with codes `invalid_tariff_selection_format`, `unknown_tariff`, or `quantity_invalid`. 
         * @param {string} schedulingId 
         * @param {number} [scheduleTimeMinutes] 
         * @param {Array<string>} [pricingTariffSelections] Optional CSV of atomic tariffId:quantity pairs (explode false). Omit for baseline pricing without quantity-based RM discount. Include all selectable tariff types; quantity may be 0. Each item must contain exactly one colon separating tariff ID (numeric string) and non-negative integer quantity. Invalid format may return 422 invalid_tariff_selection_format; unknown tariffId unknown_tariff; negative quantity quantity_invalid. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchedulingSeatMapOverview(schedulingId: string, scheduleTimeMinutes?: number, pricingTariffSelections?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<SeatMapOverview> {
            return localVarFp.getSchedulingSeatMapOverview(schedulingId, scheduleTimeMinutes, pricingTariffSelections, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SeatMapsApi - object-oriented interface
 * @export
 * @class SeatMapsApi
 * @extends {BaseAPI}
 */
export class SeatMapsApi extends BaseAPI {
    /**
     * Returns the seat map overview for a scheduling. When `pricingTariffSelections` is omitted, resource tariff prices reflect baseline RM. When present, use the same atomic tariffId:quantity pairs as `getProductSchedulings` so category tariff prices reflect quantity-based RM. Invalid selections may return 422 with codes `invalid_tariff_selection_format`, `unknown_tariff`, or `quantity_invalid`. 
     * @param {string} schedulingId 
     * @param {number} [scheduleTimeMinutes] 
     * @param {Array<string>} [pricingTariffSelections] Optional CSV of atomic tariffId:quantity pairs (explode false). Omit for baseline pricing without quantity-based RM discount. Include all selectable tariff types; quantity may be 0. Each item must contain exactly one colon separating tariff ID (numeric string) and non-negative integer quantity. Invalid format may return 422 invalid_tariff_selection_format; unknown tariffId unknown_tariff; negative quantity quantity_invalid. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeatMapsApi
     */
    public getSchedulingSeatMapOverview(schedulingId: string, scheduleTimeMinutes?: number, pricingTariffSelections?: Array<string>, options?: RawAxiosRequestConfig) {
        return SeatMapsApiFp(this.configuration).getSchedulingSeatMapOverview(schedulingId, scheduleTimeMinutes, pricingTariffSelections, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TariffGroupAttributesApi - axios parameter creator
 * @export
 */
export const TariffGroupAttributesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} productId 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {TariffGroupAttributeTypeEnum} [type] 
         * @param {GetProductTariffGroupAttributesFilterEnum} [filter] 
         * @param {Array<string>} [tariffGroupIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductTariffGroupAttributes: async (productId: string, offset?: number, limit?: number, type?: TariffGroupAttributeTypeEnum, filter?: GetProductTariffGroupAttributesFilterEnum, tariffGroupIds?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getProductTariffGroupAttributes', 'productId', productId)
            const localVarPath = `/products/{productId}/tariffGroupAttributes`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (tariffGroupIds) {
                localVarQueryParameter['tariffGroupIds'] = tariffGroupIds.join(COLLECTION_FORMATS.csv);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TariffGroupAttributesApi - functional programming interface
 * @export
 */
export const TariffGroupAttributesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TariffGroupAttributesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} productId 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {TariffGroupAttributeTypeEnum} [type] 
         * @param {GetProductTariffGroupAttributesFilterEnum} [filter] 
         * @param {Array<string>} [tariffGroupIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductTariffGroupAttributes(productId: string, offset?: number, limit?: number, type?: TariffGroupAttributeTypeEnum, filter?: GetProductTariffGroupAttributesFilterEnum, tariffGroupIds?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TariffGroupAttribute>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductTariffGroupAttributes(productId, offset, limit, type, filter, tariffGroupIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TariffGroupAttributesApi.getProductTariffGroupAttributes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TariffGroupAttributesApi - factory interface
 * @export
 */
export const TariffGroupAttributesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TariffGroupAttributesApiFp(configuration)
    return {
        /**
         * 
         * @param {string} productId 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {TariffGroupAttributeTypeEnum} [type] 
         * @param {GetProductTariffGroupAttributesFilterEnum} [filter] 
         * @param {Array<string>} [tariffGroupIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductTariffGroupAttributes(productId: string, offset?: number, limit?: number, type?: TariffGroupAttributeTypeEnum, filter?: GetProductTariffGroupAttributesFilterEnum, tariffGroupIds?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<Array<TariffGroupAttribute>> {
            return localVarFp.getProductTariffGroupAttributes(productId, offset, limit, type, filter, tariffGroupIds, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TariffGroupAttributesApi - object-oriented interface
 * @export
 * @class TariffGroupAttributesApi
 * @extends {BaseAPI}
 */
export class TariffGroupAttributesApi extends BaseAPI {
    /**
     * 
     * @param {string} productId 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {TariffGroupAttributeTypeEnum} [type] 
     * @param {GetProductTariffGroupAttributesFilterEnum} [filter] 
     * @param {Array<string>} [tariffGroupIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TariffGroupAttributesApi
     */
    public getProductTariffGroupAttributes(productId: string, offset?: number, limit?: number, type?: TariffGroupAttributeTypeEnum, filter?: GetProductTariffGroupAttributesFilterEnum, tariffGroupIds?: Array<string>, options?: RawAxiosRequestConfig) {
        return TariffGroupAttributesApiFp(this.configuration).getProductTariffGroupAttributes(productId, offset, limit, type, filter, tariffGroupIds, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetProductTariffGroupAttributesFilterEnum = {
    All: 'all',
    Active: 'active',
    Archived: 'archived'
} as const;
export type GetProductTariffGroupAttributesFilterEnum = typeof GetProductTariffGroupAttributesFilterEnum[keyof typeof GetProductTariffGroupAttributesFilterEnum];


/**
 * TariffTypeVerificationsApi - axios parameter creator
 * @export
 */
export const TariffTypeVerificationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} tariffTypeId 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTariffTypeVerifications: async (tariffTypeId: string, offset?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tariffTypeId' is not null or undefined
            assertParamExists('getTariffTypeVerifications', 'tariffTypeId', tariffTypeId)
            const localVarPath = `/tariffTypes/{tariffTypeId}/verifications`
                .replace(`{${"tariffTypeId"}}`, encodeURIComponent(String(tariffTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TariffTypeVerificationsApi - functional programming interface
 * @export
 */
export const TariffTypeVerificationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TariffTypeVerificationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} tariffTypeId 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTariffTypeVerifications(tariffTypeId: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TariffTypeVerification>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTariffTypeVerifications(tariffTypeId, offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TariffTypeVerificationsApi.getTariffTypeVerifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TariffTypeVerificationsApi - factory interface
 * @export
 */
export const TariffTypeVerificationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TariffTypeVerificationsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} tariffTypeId 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTariffTypeVerifications(tariffTypeId: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<TariffTypeVerification>> {
            return localVarFp.getTariffTypeVerifications(tariffTypeId, offset, limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TariffTypeVerificationsApi - object-oriented interface
 * @export
 * @class TariffTypeVerificationsApi
 * @extends {BaseAPI}
 */
export class TariffTypeVerificationsApi extends BaseAPI {
    /**
     * 
     * @param {string} tariffTypeId 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TariffTypeVerificationsApi
     */
    public getTariffTypeVerifications(tariffTypeId: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return TariffTypeVerificationsApiFp(this.configuration).getTariffTypeVerifications(tariffTypeId, offset, limit, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TransactionsApi - axios parameter creator
 * @export
 */
export const TransactionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} directLinkId 
         * @param {NotifyExternalAuthenticationAttemptParams} notifyExternalAuthenticationAttemptParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifyDirectLinkExternalAuthenticationAttempt: async (directLinkId: string, notifyExternalAuthenticationAttemptParams: NotifyExternalAuthenticationAttemptParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'directLinkId' is not null or undefined
            assertParamExists('notifyDirectLinkExternalAuthenticationAttempt', 'directLinkId', directLinkId)
            // verify required parameter 'notifyExternalAuthenticationAttemptParams' is not null or undefined
            assertParamExists('notifyDirectLinkExternalAuthenticationAttempt', 'notifyExternalAuthenticationAttemptParams', notifyExternalAuthenticationAttemptParams)
            const localVarPath = `/directLinks/{directLinkId}/notifyExternalAuthenticationAttempt`
                .replace(`{${"directLinkId"}}`, encodeURIComponent(String(directLinkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notifyExternalAuthenticationAttemptParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orderId 
         * @param {NotifyExternalAuthenticationAttemptParams} notifyExternalAuthenticationAttemptParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifyOrderExternalAuthenticationAttempt: async (orderId: string, notifyExternalAuthenticationAttemptParams: NotifyExternalAuthenticationAttemptParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('notifyOrderExternalAuthenticationAttempt', 'orderId', orderId)
            // verify required parameter 'notifyExternalAuthenticationAttemptParams' is not null or undefined
            assertParamExists('notifyOrderExternalAuthenticationAttempt', 'notifyExternalAuthenticationAttemptParams', notifyExternalAuthenticationAttemptParams)
            const localVarPath = `/orders/{orderId}/notifyExternalAuthenticationAttempt`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notifyExternalAuthenticationAttemptParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} saleChangeId 
         * @param {NotifyExternalAuthenticationAttemptParams} notifyExternalAuthenticationAttemptParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifySaleChangeExternalAuthenticationAttempt: async (saleChangeId: string, notifyExternalAuthenticationAttemptParams: NotifyExternalAuthenticationAttemptParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'saleChangeId' is not null or undefined
            assertParamExists('notifySaleChangeExternalAuthenticationAttempt', 'saleChangeId', saleChangeId)
            // verify required parameter 'notifyExternalAuthenticationAttemptParams' is not null or undefined
            assertParamExists('notifySaleChangeExternalAuthenticationAttempt', 'notifyExternalAuthenticationAttemptParams', notifyExternalAuthenticationAttemptParams)
            const localVarPath = `/saleChanges/{saleChangeId}/notifyExternalAuthenticationAttempt`
                .replace(`{${"saleChangeId"}}`, encodeURIComponent(String(saleChangeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notifyExternalAuthenticationAttemptParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} saleId 
         * @param {NotifyExternalAuthenticationAttemptParams} notifyExternalAuthenticationAttemptParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifySaleExternalAuthenticationAttempt: async (saleId: string, notifyExternalAuthenticationAttemptParams: NotifyExternalAuthenticationAttemptParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'saleId' is not null or undefined
            assertParamExists('notifySaleExternalAuthenticationAttempt', 'saleId', saleId)
            // verify required parameter 'notifyExternalAuthenticationAttemptParams' is not null or undefined
            assertParamExists('notifySaleExternalAuthenticationAttempt', 'notifyExternalAuthenticationAttemptParams', notifyExternalAuthenticationAttemptParams)
            const localVarPath = `/sales/{saleId}/notifyExternalAuthenticationAttempt`
                .replace(`{${"saleId"}}`, encodeURIComponent(String(saleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notifyExternalAuthenticationAttemptParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Records what the checkout reports about a 3DS challenge it could not see through, such as a timeout or a frame that did not load. The transaction does not change. Only a transaction still waiting for a challenge accepts it.
         * @param {string} transactionId 
         * @param {NotifyTransactionExternalAuthenticationAttemptParams} notifyTransactionExternalAuthenticationAttemptParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifyTransactionExternalAuthenticationAttempt: async (transactionId: string, notifyTransactionExternalAuthenticationAttemptParams: NotifyTransactionExternalAuthenticationAttemptParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'transactionId' is not null or undefined
            assertParamExists('notifyTransactionExternalAuthenticationAttempt', 'transactionId', transactionId)
            // verify required parameter 'notifyTransactionExternalAuthenticationAttemptParams' is not null or undefined
            assertParamExists('notifyTransactionExternalAuthenticationAttempt', 'notifyTransactionExternalAuthenticationAttemptParams', notifyTransactionExternalAuthenticationAttemptParams)
            const localVarPath = `/transactions/{transactionId}/notifyExternalAuthenticationAttempt`
                .replace(`{${"transactionId"}}`, encodeURIComponent(String(transactionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notifyTransactionExternalAuthenticationAttemptParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} directLinkId 
         * @param {TransactionRequest} transactionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transactDirectLink: async (directLinkId: string, transactionRequest: TransactionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'directLinkId' is not null or undefined
            assertParamExists('transactDirectLink', 'directLinkId', directLinkId)
            // verify required parameter 'transactionRequest' is not null or undefined
            assertParamExists('transactDirectLink', 'transactionRequest', transactionRequest)
            const localVarPath = `/directLinks/{directLinkId}/transact`
                .replace(`{${"directLinkId"}}`, encodeURIComponent(String(directLinkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transactionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orderId 
         * @param {TransactionRequest} transactionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transactOrder: async (orderId: string, transactionRequest: TransactionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('transactOrder', 'orderId', orderId)
            // verify required parameter 'transactionRequest' is not null or undefined
            assertParamExists('transactOrder', 'transactionRequest', transactionRequest)
            const localVarPath = `/orders/{orderId}/transact`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transactionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} saleId 
         * @param {TransactionRequest} transactionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transactSale: async (saleId: string, transactionRequest: TransactionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'saleId' is not null or undefined
            assertParamExists('transactSale', 'saleId', saleId)
            // verify required parameter 'transactionRequest' is not null or undefined
            assertParamExists('transactSale', 'transactionRequest', transactionRequest)
            const localVarPath = `/sales/{saleId}/transact`
                .replace(`{${"saleId"}}`, encodeURIComponent(String(saleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transactionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} saleChangeId 
         * @param {TransactionRequest} transactionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transactSaleChange: async (saleChangeId: string, transactionRequest: TransactionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'saleChangeId' is not null or undefined
            assertParamExists('transactSaleChange', 'saleChangeId', saleChangeId)
            // verify required parameter 'transactionRequest' is not null or undefined
            assertParamExists('transactSaleChange', 'transactionRequest', transactionRequest)
            const localVarPath = `/saleChanges/{saleChangeId}/transact`
                .replace(`{${"saleChangeId"}}`, encodeURIComponent(String(saleChangeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transactionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TransactionsApi - functional programming interface
 * @export
 */
export const TransactionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TransactionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} directLinkId 
         * @param {NotifyExternalAuthenticationAttemptParams} notifyExternalAuthenticationAttemptParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notifyDirectLinkExternalAuthenticationAttempt(directLinkId: string, notifyExternalAuthenticationAttemptParams: NotifyExternalAuthenticationAttemptParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notifyDirectLinkExternalAuthenticationAttempt(directLinkId, notifyExternalAuthenticationAttemptParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransactionsApi.notifyDirectLinkExternalAuthenticationAttempt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orderId 
         * @param {NotifyExternalAuthenticationAttemptParams} notifyExternalAuthenticationAttemptParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notifyOrderExternalAuthenticationAttempt(orderId: string, notifyExternalAuthenticationAttemptParams: NotifyExternalAuthenticationAttemptParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notifyOrderExternalAuthenticationAttempt(orderId, notifyExternalAuthenticationAttemptParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransactionsApi.notifyOrderExternalAuthenticationAttempt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} saleChangeId 
         * @param {NotifyExternalAuthenticationAttemptParams} notifyExternalAuthenticationAttemptParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notifySaleChangeExternalAuthenticationAttempt(saleChangeId: string, notifyExternalAuthenticationAttemptParams: NotifyExternalAuthenticationAttemptParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notifySaleChangeExternalAuthenticationAttempt(saleChangeId, notifyExternalAuthenticationAttemptParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransactionsApi.notifySaleChangeExternalAuthenticationAttempt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} saleId 
         * @param {NotifyExternalAuthenticationAttemptParams} notifyExternalAuthenticationAttemptParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notifySaleExternalAuthenticationAttempt(saleId: string, notifyExternalAuthenticationAttemptParams: NotifyExternalAuthenticationAttemptParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notifySaleExternalAuthenticationAttempt(saleId, notifyExternalAuthenticationAttemptParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransactionsApi.notifySaleExternalAuthenticationAttempt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Records what the checkout reports about a 3DS challenge it could not see through, such as a timeout or a frame that did not load. The transaction does not change. Only a transaction still waiting for a challenge accepts it.
         * @param {string} transactionId 
         * @param {NotifyTransactionExternalAuthenticationAttemptParams} notifyTransactionExternalAuthenticationAttemptParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notifyTransactionExternalAuthenticationAttempt(transactionId: string, notifyTransactionExternalAuthenticationAttemptParams: NotifyTransactionExternalAuthenticationAttemptParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notifyTransactionExternalAuthenticationAttempt(transactionId, notifyTransactionExternalAuthenticationAttemptParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransactionsApi.notifyTransactionExternalAuthenticationAttempt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} directLinkId 
         * @param {TransactionRequest} transactionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transactDirectLink(directLinkId: string, transactionRequest: TransactionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Transaction>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transactDirectLink(directLinkId, transactionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransactionsApi.transactDirectLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orderId 
         * @param {TransactionRequest} transactionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transactOrder(orderId: string, transactionRequest: TransactionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Transaction>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transactOrder(orderId, transactionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransactionsApi.transactOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} saleId 
         * @param {TransactionRequest} transactionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transactSale(saleId: string, transactionRequest: TransactionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Transaction>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transactSale(saleId, transactionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransactionsApi.transactSale']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} saleChangeId 
         * @param {TransactionRequest} transactionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transactSaleChange(saleChangeId: string, transactionRequest: TransactionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Transaction>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transactSaleChange(saleChangeId, transactionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransactionsApi.transactSaleChange']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TransactionsApi - factory interface
 * @export
 */
export const TransactionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TransactionsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} directLinkId 
         * @param {NotifyExternalAuthenticationAttemptParams} notifyExternalAuthenticationAttemptParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifyDirectLinkExternalAuthenticationAttempt(directLinkId: string, notifyExternalAuthenticationAttemptParams: NotifyExternalAuthenticationAttemptParams, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.notifyDirectLinkExternalAuthenticationAttempt(directLinkId, notifyExternalAuthenticationAttemptParams, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} orderId 
         * @param {NotifyExternalAuthenticationAttemptParams} notifyExternalAuthenticationAttemptParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifyOrderExternalAuthenticationAttempt(orderId: string, notifyExternalAuthenticationAttemptParams: NotifyExternalAuthenticationAttemptParams, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.notifyOrderExternalAuthenticationAttempt(orderId, notifyExternalAuthenticationAttemptParams, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} saleChangeId 
         * @param {NotifyExternalAuthenticationAttemptParams} notifyExternalAuthenticationAttemptParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifySaleChangeExternalAuthenticationAttempt(saleChangeId: string, notifyExternalAuthenticationAttemptParams: NotifyExternalAuthenticationAttemptParams, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.notifySaleChangeExternalAuthenticationAttempt(saleChangeId, notifyExternalAuthenticationAttemptParams, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} saleId 
         * @param {NotifyExternalAuthenticationAttemptParams} notifyExternalAuthenticationAttemptParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifySaleExternalAuthenticationAttempt(saleId: string, notifyExternalAuthenticationAttemptParams: NotifyExternalAuthenticationAttemptParams, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.notifySaleExternalAuthenticationAttempt(saleId, notifyExternalAuthenticationAttemptParams, options).then((request) => request(axios, basePath));
        },
        /**
         * Records what the checkout reports about a 3DS challenge it could not see through, such as a timeout or a frame that did not load. The transaction does not change. Only a transaction still waiting for a challenge accepts it.
         * @param {string} transactionId 
         * @param {NotifyTransactionExternalAuthenticationAttemptParams} notifyTransactionExternalAuthenticationAttemptParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifyTransactionExternalAuthenticationAttempt(transactionId: string, notifyTransactionExternalAuthenticationAttemptParams: NotifyTransactionExternalAuthenticationAttemptParams, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.notifyTransactionExternalAuthenticationAttempt(transactionId, notifyTransactionExternalAuthenticationAttemptParams, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} directLinkId 
         * @param {TransactionRequest} transactionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transactDirectLink(directLinkId: string, transactionRequest: TransactionRequest, options?: RawAxiosRequestConfig): AxiosPromise<Transaction> {
            return localVarFp.transactDirectLink(directLinkId, transactionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} orderId 
         * @param {TransactionRequest} transactionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transactOrder(orderId: string, transactionRequest: TransactionRequest, options?: RawAxiosRequestConfig): AxiosPromise<Transaction> {
            return localVarFp.transactOrder(orderId, transactionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} saleId 
         * @param {TransactionRequest} transactionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transactSale(saleId: string, transactionRequest: TransactionRequest, options?: RawAxiosRequestConfig): AxiosPromise<Transaction> {
            return localVarFp.transactSale(saleId, transactionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} saleChangeId 
         * @param {TransactionRequest} transactionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transactSaleChange(saleChangeId: string, transactionRequest: TransactionRequest, options?: RawAxiosRequestConfig): AxiosPromise<Transaction> {
            return localVarFp.transactSaleChange(saleChangeId, transactionRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TransactionsApi - object-oriented interface
 * @export
 * @class TransactionsApi
 * @extends {BaseAPI}
 */
export class TransactionsApi extends BaseAPI {
    /**
     * 
     * @param {string} directLinkId 
     * @param {NotifyExternalAuthenticationAttemptParams} notifyExternalAuthenticationAttemptParams 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public notifyDirectLinkExternalAuthenticationAttempt(directLinkId: string, notifyExternalAuthenticationAttemptParams: NotifyExternalAuthenticationAttemptParams, options?: RawAxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).notifyDirectLinkExternalAuthenticationAttempt(directLinkId, notifyExternalAuthenticationAttemptParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} orderId 
     * @param {NotifyExternalAuthenticationAttemptParams} notifyExternalAuthenticationAttemptParams 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public notifyOrderExternalAuthenticationAttempt(orderId: string, notifyExternalAuthenticationAttemptParams: NotifyExternalAuthenticationAttemptParams, options?: RawAxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).notifyOrderExternalAuthenticationAttempt(orderId, notifyExternalAuthenticationAttemptParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} saleChangeId 
     * @param {NotifyExternalAuthenticationAttemptParams} notifyExternalAuthenticationAttemptParams 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public notifySaleChangeExternalAuthenticationAttempt(saleChangeId: string, notifyExternalAuthenticationAttemptParams: NotifyExternalAuthenticationAttemptParams, options?: RawAxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).notifySaleChangeExternalAuthenticationAttempt(saleChangeId, notifyExternalAuthenticationAttemptParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} saleId 
     * @param {NotifyExternalAuthenticationAttemptParams} notifyExternalAuthenticationAttemptParams 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public notifySaleExternalAuthenticationAttempt(saleId: string, notifyExternalAuthenticationAttemptParams: NotifyExternalAuthenticationAttemptParams, options?: RawAxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).notifySaleExternalAuthenticationAttempt(saleId, notifyExternalAuthenticationAttemptParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Records what the checkout reports about a 3DS challenge it could not see through, such as a timeout or a frame that did not load. The transaction does not change. Only a transaction still waiting for a challenge accepts it.
     * @param {string} transactionId 
     * @param {NotifyTransactionExternalAuthenticationAttemptParams} notifyTransactionExternalAuthenticationAttemptParams 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public notifyTransactionExternalAuthenticationAttempt(transactionId: string, notifyTransactionExternalAuthenticationAttemptParams: NotifyTransactionExternalAuthenticationAttemptParams, options?: RawAxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).notifyTransactionExternalAuthenticationAttempt(transactionId, notifyTransactionExternalAuthenticationAttemptParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} directLinkId 
     * @param {TransactionRequest} transactionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public transactDirectLink(directLinkId: string, transactionRequest: TransactionRequest, options?: RawAxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).transactDirectLink(directLinkId, transactionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} orderId 
     * @param {TransactionRequest} transactionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public transactOrder(orderId: string, transactionRequest: TransactionRequest, options?: RawAxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).transactOrder(orderId, transactionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} saleId 
     * @param {TransactionRequest} transactionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public transactSale(saleId: string, transactionRequest: TransactionRequest, options?: RawAxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).transactSale(saleId, transactionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} saleChangeId 
     * @param {TransactionRequest} transactionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public transactSaleChange(saleChangeId: string, transactionRequest: TransactionRequest, options?: RawAxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).transactSaleChange(saleChangeId, transactionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UpsellOffersApi - axios parameter creator
 * @export
 */
export const UpsellOffersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns the upsell product offers for the given origin product, already resolved on the server: anti-loop (the origin product is never suggested), capped at 5 results, ordered by descending priority. When a cartId is provided, products already present in the cart are filtered out. Returns an empty array when the product has upsell disabled or no eligible candidates.
         * @param {string} productId 
         * @param {string} [cartId] When provided, products already present in this cart are filtered out of the offers.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductUpsellOffers: async (productId: string, cartId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getProductUpsellOffers', 'productId', productId)
            const localVarPath = `/products/{productId}/upsellOffers`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)

            if (cartId !== undefined) {
                localVarQueryParameter['cartId'] = cartId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UpsellOffersApi - functional programming interface
 * @export
 */
export const UpsellOffersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UpsellOffersApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns the upsell product offers for the given origin product, already resolved on the server: anti-loop (the origin product is never suggested), capped at 5 results, ordered by descending priority. When a cartId is provided, products already present in the cart are filtered out. Returns an empty array when the product has upsell disabled or no eligible candidates.
         * @param {string} productId 
         * @param {string} [cartId] When provided, products already present in this cart are filtered out of the offers.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductUpsellOffers(productId: string, cartId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UpsellOffer>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductUpsellOffers(productId, cartId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UpsellOffersApi.getProductUpsellOffers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UpsellOffersApi - factory interface
 * @export
 */
export const UpsellOffersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UpsellOffersApiFp(configuration)
    return {
        /**
         * Returns the upsell product offers for the given origin product, already resolved on the server: anti-loop (the origin product is never suggested), capped at 5 results, ordered by descending priority. When a cartId is provided, products already present in the cart are filtered out. Returns an empty array when the product has upsell disabled or no eligible candidates.
         * @param {string} productId 
         * @param {string} [cartId] When provided, products already present in this cart are filtered out of the offers.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductUpsellOffers(productId: string, cartId?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<UpsellOffer>> {
            return localVarFp.getProductUpsellOffers(productId, cartId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UpsellOffersApi - object-oriented interface
 * @export
 * @class UpsellOffersApi
 * @extends {BaseAPI}
 */
export class UpsellOffersApi extends BaseAPI {
    /**
     * Returns the upsell product offers for the given origin product, already resolved on the server: anti-loop (the origin product is never suggested), capped at 5 results, ordered by descending priority. When a cartId is provided, products already present in the cart are filtered out. Returns an empty array when the product has upsell disabled or no eligible candidates.
     * @param {string} productId 
     * @param {string} [cartId] When provided, products already present in this cart are filtered out of the offers.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpsellOffersApi
     */
    public getProductUpsellOffers(productId: string, cartId?: string, options?: RawAxiosRequestConfig) {
        return UpsellOffersApiFp(this.configuration).getProductUpsellOffers(productId, cartId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VouchersApi - axios parameter creator
 * @export
 */
export const VouchersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} orderId 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderVouchers: async (orderId: string, offset?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getOrderVouchers', 'orderId', orderId)
            const localVarPath = `/orders/{orderId}/vouchers`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderVouchersPdf: async (orderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getOrderVouchersPdf', 'orderId', orderId)
            const localVarPath = `/orders/{orderId}/vouchers/pdf`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a PDF bundling the vouchers issued for a single reservation (booking) within a sale. The vouchers are listed in core (getReservationVouchers); the PDF is rendered by the legacy app (planne-app) and converted via Gotenberg, like the order/sale variants.
         * @summary Downloads the vouchers of a single reservation as a PDF
         * @param {string} reservationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReservationVouchersPdf: async (reservationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reservationId' is not null or undefined
            assertParamExists('getReservationVouchersPdf', 'reservationId', reservationId)
            const localVarPath = `/reservations/{reservationId}/vouchers/pdf`
                .replace(`{${"reservationId"}}`, encodeURIComponent(String(reservationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} saleId 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSaleVouchers: async (saleId: string, offset?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'saleId' is not null or undefined
            assertParamExists('getSaleVouchers', 'saleId', saleId)
            const localVarPath = `/sales/{saleId}/vouchers`
                .replace(`{${"saleId"}}`, encodeURIComponent(String(saleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} saleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSaleVouchersPdf: async (saleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'saleId' is not null or undefined
            assertParamExists('getSaleVouchersPdf', 'saleId', saleId)
            const localVarPath = `/sales/{saleId}/vouchers/pdf`
                .replace(`{${"saleId"}}`, encodeURIComponent(String(saleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} voucherId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVoucherPdf: async (voucherId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'voucherId' is not null or undefined
            assertParamExists('getVoucherPdf', 'voucherId', voucherId)
            const localVarPath = `/vouchers/{voucherId}/pdf`
                .replace(`{${"voucherId"}}`, encodeURIComponent(String(voucherId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} voucherId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVoucherQrCode: async (voucherId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'voucherId' is not null or undefined
            assertParamExists('getVoucherQrCode', 'voucherId', voucherId)
            const localVarPath = `/vouchers/{voucherId}/qrcode`
                .replace(`{${"voucherId"}}`, encodeURIComponent(String(voucherId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AppTokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-App-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VouchersApi - functional programming interface
 * @export
 */
export const VouchersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VouchersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} orderId 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderVouchers(orderId: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Voucher>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderVouchers(orderId, offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VouchersApi.getOrderVouchers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderVouchersPdf(orderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderVouchersPdf(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VouchersApi.getOrderVouchersPdf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a PDF bundling the vouchers issued for a single reservation (booking) within a sale. The vouchers are listed in core (getReservationVouchers); the PDF is rendered by the legacy app (planne-app) and converted via Gotenberg, like the order/sale variants.
         * @summary Downloads the vouchers of a single reservation as a PDF
         * @param {string} reservationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReservationVouchersPdf(reservationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReservationVouchersPdf(reservationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VouchersApi.getReservationVouchersPdf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} saleId 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSaleVouchers(saleId: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Voucher>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSaleVouchers(saleId, offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VouchersApi.getSaleVouchers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} saleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSaleVouchersPdf(saleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSaleVouchersPdf(saleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VouchersApi.getSaleVouchersPdf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} voucherId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVoucherPdf(voucherId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVoucherPdf(voucherId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VouchersApi.getVoucherPdf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} voucherId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVoucherQrCode(voucherId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoucherQrCode>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVoucherQrCode(voucherId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VouchersApi.getVoucherQrCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VouchersApi - factory interface
 * @export
 */
export const VouchersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VouchersApiFp(configuration)
    return {
        /**
         * 
         * @param {string} orderId 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderVouchers(orderId: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<Voucher>> {
            return localVarFp.getOrderVouchers(orderId, offset, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderVouchersPdf(orderId: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getOrderVouchersPdf(orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a PDF bundling the vouchers issued for a single reservation (booking) within a sale. The vouchers are listed in core (getReservationVouchers); the PDF is rendered by the legacy app (planne-app) and converted via Gotenberg, like the order/sale variants.
         * @summary Downloads the vouchers of a single reservation as a PDF
         * @param {string} reservationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReservationVouchersPdf(reservationId: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getReservationVouchersPdf(reservationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} saleId 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSaleVouchers(saleId: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<Voucher>> {
            return localVarFp.getSaleVouchers(saleId, offset, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} saleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSaleVouchersPdf(saleId: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getSaleVouchersPdf(saleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} voucherId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVoucherPdf(voucherId: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getVoucherPdf(voucherId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} voucherId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVoucherQrCode(voucherId: string, options?: RawAxiosRequestConfig): AxiosPromise<VoucherQrCode> {
            return localVarFp.getVoucherQrCode(voucherId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VouchersApi - object-oriented interface
 * @export
 * @class VouchersApi
 * @extends {BaseAPI}
 */
export class VouchersApi extends BaseAPI {
    /**
     * 
     * @param {string} orderId 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VouchersApi
     */
    public getOrderVouchers(orderId: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return VouchersApiFp(this.configuration).getOrderVouchers(orderId, offset, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} orderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VouchersApi
     */
    public getOrderVouchersPdf(orderId: string, options?: RawAxiosRequestConfig) {
        return VouchersApiFp(this.configuration).getOrderVouchersPdf(orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a PDF bundling the vouchers issued for a single reservation (booking) within a sale. The vouchers are listed in core (getReservationVouchers); the PDF is rendered by the legacy app (planne-app) and converted via Gotenberg, like the order/sale variants.
     * @summary Downloads the vouchers of a single reservation as a PDF
     * @param {string} reservationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VouchersApi
     */
    public getReservationVouchersPdf(reservationId: string, options?: RawAxiosRequestConfig) {
        return VouchersApiFp(this.configuration).getReservationVouchersPdf(reservationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} saleId 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VouchersApi
     */
    public getSaleVouchers(saleId: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return VouchersApiFp(this.configuration).getSaleVouchers(saleId, offset, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} saleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VouchersApi
     */
    public getSaleVouchersPdf(saleId: string, options?: RawAxiosRequestConfig) {
        return VouchersApiFp(this.configuration).getSaleVouchersPdf(saleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} voucherId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VouchersApi
     */
    public getVoucherPdf(voucherId: string, options?: RawAxiosRequestConfig) {
        return VouchersApiFp(this.configuration).getVoucherPdf(voucherId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} voucherId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VouchersApi
     */
    public getVoucherQrCode(voucherId: string, options?: RawAxiosRequestConfig) {
        return VouchersApiFp(this.configuration).getVoucherQrCode(voucherId, options).then((request) => request(this.axios, this.basePath));
    }
}



